import React, { useRef, useState,useEffect, useLayoutEffect } from "react";
import MonthYearPicker from "../../components/date-monthyear";
import MiniSideBar from "../../components/mini-sidebar";
import { Icon } from "@chakra-ui/icons";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import {
  Box,
  Card,
  CardFooter,
  Center,
  Circle,
  Divider,
  Flex,
  Image,
  InputGroup,
  Menu,
  MenuButton,
  Spacer,
  Stack,
  Text,
  Textarea,
  VStack,
  MenuList,
  MenuItem,
  InputRightElement,
  Input,
  Td,
  Tr,
  Step,
  StepIndicator,
  StepTitle,
  StepDescription,
  Stepper,
  StepSeparator,
  UnorderedList,
  ListItem,
  CardBody,
  ToastProvider,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  Radio,
  useDisclosure,
  Collapse,
  SimpleGrid,
} from "@chakra-ui/react";
import SecondaryNav from "../../components/seconday-nav";
import PrimaryButton from "../../components/primary-button";
import MiniDropdownInput from "../../components/mini-dropdown";
import GrayCard from "../../components/card";
import SearchBar from "../../components/search-bar";
import TypingLoader from "../../components/typing-loader";
import {COLORS} from "../../components/styles/colors";
import ToggleTab from "../../components/accordion";
import DynamicModal from "../../components/dynamic-modal";
import ModalRight from "../../components/modal-right";
import { Link, NavLink, useLocation } from "react-router-dom";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import SimpleTable from "../../components/simple-table";
import moment from "moment";
import { DropdownInput, PrimaryInput, Toaster } from "../../components";

import {
    BrowserRouter as Router,
    generatePath,
    Routes,
    Route,
    useNavigate,
    useParams,
} from "react-router-dom";
import { actionAccessMain, downloadDocument, formatDate_YYYY_MM_DD, getLoginID, handleAlphaDotAndSpace, handleAlphaNumericDotAndSpace, useScreenType, validationOfNumberWithOnly1Decimal } from "../../auth";
import { AddMedicine, DeleteMedication, DeleteMedicine, EditMedicine, FetchFilteredMedicinesList, FetchMedicationsData, FetchMedicineAIAnswer, FetchMedicineAIPrompts, FetchMedicineViewDetails, FetchMyHealthAIData, GetMedicineName } from "../../middleware/services/medicines";
import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { Button } from "react-day-picker";
import { uploadImageInProfile } from "../../middleware/services/profile";
import { GetAIMedicineComposition } from "../../middleware/services/visits/patient-overview/updatedoctornotes";
import FetchData from "../../middleware/client";
import AiModal from '../../components/ai-modal/index';
import DatePicker from "../../components/date-picker";
import { format } from "date-fns";
import DropdownInputForVitals from "../../components/dropdown-input-forVitals";
import { GPUChatAudioManager } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManager";
import { useForm } from "react-hook-form";
import { useGPUTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useGPUTranscriber";
import { CorrectInstructionsUsingAI, CorrectMedicalTermsUsingAI } from "../../middleware/services/visits/aicalls";
import DropdownWithMultiLingual from "../../components/dropdown-multilingual";
import { GPUChatAudioManagerSpeechMode } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManagerSpeechMode";
import { AudioDisplayForClutter } from "../../components/patient-health/doctor-notes/notes-transcription/utils/audio-display-multi-lingual";
import { useHybridTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useHybridTranscriber";
import { languageCodeMap, languageOptions } from "../../components/language-dropdown";

// Helper function to get the meal timing option label
const getMealTimingLabel = (morning, afternoon, night) => {
  const pattern = `${morning || 0}-${afternoon || 0}-${night || 0}`;
  const labelMap = {
    "1-0-0": "1-0-0",
    "0-1-0": "0-1-0",
    "0-0-1": "0-0-1",
    "1-1-0": "1-1-0",
    "1-0-1": "1-0-1",
    "0-1-1": "0-1-1",
    "1-1-1": "1-1-1",
    "0-0-0": "0-0-0"
    // "1-0-0": "1-0-0 (Morning)",
    // "0-1-0": "0-1-0 (Afternoon)",
    // "0-0-1": "0-0-1 (Night)",
    // "1-1-0": "1-1-0 (Morning & Afternoon)",
    // "1-0-1": "1-0-1 (Morning & Night)",
    // "0-1-1": "0-1-1 (Afternoon & Night)",
    // "1-1-1": "1-1-1 (All three)",
    // "0-0-0": "0-0-0 (None)"
  };
  return labelMap[pattern] || "1-0-0"; // Default to morning if pattern not found
};

// Helper function to parse meal timing option value
const parseMealTiming = (optionValue) => {
  // Extract only the numeric part (e.g., "0-0-1" from "0-0-1 (Night)")
  const numericPart = optionValue.split(' ')[0];
  const [morning, afternoon, night] = numericPart.split('-').map(Number);
  return { morning, afternoon, night };
};

const MedicineViewIndex = () => {
  var [doctorid, setDoctorid] = useState(getLoginID());
  var [medicineViewData, setMedicineViewData] = useState(null);
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const screenType = useScreenType();
  const navigate = useNavigate();
  const { showSuccessToast, showErrorToast } = Toaster();

  const addmedications = useRef();
  const fileInputRef = useRef(null);
  const AIChatModel = useRef();
  const chatContainerRef = useRef(null);
  const learnMoreModal = React.useRef();
  const editmedications = React.useRef();
  const detailsmodel = React.useRef();
  const fileInputRefUpdate = useRef(null);
  const dynamicModal = React.useRef();
  const favouritemedications = React.useRef();
  const administration = React.useRef();

  // Pagination 
  const [name, setName] = useState("");
  // const [lastUsedDate, setLastUsedDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [modalData, setModalData] = useState({
    duration: '',
    frequency: '',
    frequencytime: '',
    frequencyvalue: '',
    morning: 0,
    afternoon: 0,
    evening: 0,
    beforefood: 0,
    afterfood: 0,
    instructions: '',
  });
  
  let itemPerPageCommonValue = 50;

  let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
  let [pageno, setPageno] = useState(1);


  // states for item count display
  let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  let [countFrom, setCountFrom] = useState(1);
  let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);

  const [showFilterCount, setShowFilterCount] = useState(false);
  const [noData, setNoData] = useState(false);


  // add medicine
  const [Composition, setComposition] = useState("");
  const [dosage, setMedicineDosage] = useState(null);
  const [hospitalname, setHospitalname] = useState(null);
  const [medicinename, setMedicineName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [medicineexpirydate, setMedicineExpiryDate] = useState('');
  const [benifit, setBenifit] = useState('')
  const [sideEffects, setSideEffects] = useState('')
  const [dosageunit, setMedicineDosageUnit] = useState("mg");
  const [frequency, setMedicineDosageFrequency] = useState("");
  const [medicinetype, setMedicineType] = useState("Tablet");
  const [filterMedicinetype, setFilterMedicinetype] = useState("");
  const [morning, setMorning] = useState("0");
  const [afternoon, setAfternoon] = useState("0");
  const [setevening, setEvening] = useState("0");
  const [setnight, setNight] = useState("0");
  const [beforefood, setBeforefood] = useState("0");
  const [afterfood, setAfterfood] = useState("0");
  const [prescribedby, setPrescribedBy] = useState(null);
  const [suggestions, setSuggestions] = useState({});
  const [treatmentteamdata, setTreatmentTeamData] = useState("");
  const [showDocNamesDropdown , setShowDocNamesDropdown] = useState(true)
  const [showAIModal , setShowAIModal] = useState(true)
  const [isChecked , setIsChecked] = useState(0)
  const [filenameArray, setFilenameArray] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [boolValForSuggestions , setBoolValForSuggestions] = useState(true)
  const [medicineTypeRadio, setMedicineTypeRadio] = useState(null)
  const [medicinetypeFilter, setMedicineTypeFilter] = useState("All")
  const [aianswers, setAIAnswers] = useState([]);
  const [remainingquestions, setRemainingQuestions] = useState([]);
  const [aiquestion, setAIAnalysis] = useState(null);
  const [AiInput, setAiInput] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const [animate, setAnimate] = useState(false);

  // Edit Medicine States
  var [id, setID] = useState("");
  const [minDateStateEdit , setMinDateStateEdit] = useState('')
  const [maxDateStateEdit , setMaxDateStateEdit] = useState('')
  const [filenameforUpload, setFilenameforUpload] = useState([])
  const today = moment().format("YYYY-MM-DD HH:mm:ss.SSS");
  const [medicinedata, setMedicinedata] = useState(null);
  const [documentURLForEdit, setDocumentURLForEdit] = useState([]);
  var [title, setTitle] = useState();
  var [data, setData] = useState(null);

  const [ toDateMinMax , setToDateMinMax] = useState("")
  const [ fromDateMinMax , setFromDateMinMax] = useState("")

  const TableHeader = [
    { key: "medicine", label: "Medicine Name" },
    { key: "composition", label: "Composition" },
    { key: "dosage", label: "strength" },
    { key: "consumption", label: "Consumption" },
    { key: "lastused", label: "Last Used" },
    { key: "actions", label: "Actions" },
  ];

  const [actionAccess, setActionAccess] = useState(null);
  const { isOpen, onToggle } = useDisclosure()

  // states of new inputs of medication ---
  const [routeOfAdministration, setRouteOfAdministration] = useState(null);
  const [timing, setTiming] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const [areaOfApplication, setAreaOfApplication] = useState(null);
  const [productQuantity, setProductQuantity] = useState("1");
  const [drugClass, setDrugClass] = useState(null);
  const [therapeutic, setTherapeutic] = useState(null);
  const [manufacturer, setManufacturer] = useState(null);
  const [instructions, setInstructions] = useState(null);
  const [editInstructions, setEditInstructions] = useState(null);
  const [diluent, setDiluent] = useState(null);
  const [infusionDuration, setInfusionDuration] = useState(null);
  const [infusionFrequency, setInfusionFrequency] = useState(null);
  const [additives, setAdditives] = useState(null);
  const [duration, setDuration] = useState(null);

  const [medicineFreqValue, setMedicineFreqValue] = useState("")
  const [medicineFreqUnit, setMedicineFreqUnit] = useState("")
  //   const [ durationValue , setDurationValue] = useState("")
  //   const [ durationUnit , setDurationUnit] = useState("")

  const [rateOfInfusionValue, setRateOfInfusionValue] = useState(null);
  const [rateOfInfusionUnit , setRateOfInfusionUnit] = useState("ml/hr")
  const [durationValue, setDurationValue] = useState("3");
  const [durationUnit, setDurationUnit] = useState("Days");
  const [frequencyUnit, setFrequencyUnit] = useState(null);

  const [sos, setSOS] = useState(null);
  const [customMessage, setCustomMessage] = useState(null);
  const [foodTiming, setFoodTiming] = useState(""); 

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  // ---

  // useEffect(() => {
  //   fetchMedicinesView();       
  // }, []);
  // const fetchMedicinesView = async () => {
  //   showLoader()
  //   try {
  //     const result = await FetchMedicineViewDetails({
  //       doctorid,
  //     });
  //     if (result != null) {
  //       setMedicineViewData(result);
  //     } else {
  //       //setPatientData("");
  //       dismissLoader()
  //     }
  //     dismissLoader()
  //   } catch (error) {
  //     console.error("Error in home:", error);
  //   }
  // };

  // Pagination & Page load

  useEffect(() => {
    
  setActionAccess(actionAccessMain(6))
    showLoader();
    var input = {
      // "doctorid": getLoginID(),
      type: 'catalog',
      "pageno": 1,
      pagesize
    }
    var getMedicinesList = async () => {
      try{
        var result = await FetchMedicineViewDetails(input);
        if(result?.data){
          setMedicineViewData(result.data);
          let count = result?.count;
          let pageno = result?.pageno;
          let pagesize = result?.pagesize;
          setTotalItemCount(count)
          let totalPagesCalc = count / pagesize;
          let totalPagesCount = Math.ceil(totalPagesCalc);

          setTotalPages(totalPagesCount);

          setTotalItemCount(count)
          if(result && result.count  < itemPerPageCommonValue){
            setCountTo(result.count)
            setTotalExceedsPageCount(true)
          }else if(result.count > itemPerPageCommonValue && pageno == 1) {
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }

        } else{
          setMedicineViewData([])
        }
      } catch (error) {
        console.error("Error in home:", error);
      }
      dismissLoader();
    };

    getMedicinesList();
  }, [refresh])

  const getFilteredResults = () => {
    // if(!name && !email && !specialization && (!status || status== '')){
    //       showErrorToast('Please enter the inputs to filter.')
    //       return;
    //     }
    const tableContainer = document.querySelector('.tableContainer');
    if (tableContainer) {
      tableContainer.scrollTop = 0;
    }
    showLoader();

    const trimmedName = name?.trim();
    var input = {
      "doctorid": getLoginID(),
        // "searchtext": trimmedName,
        composition: search.composition?.trim() || null,
        dosage: search.dosage?.trim() || null,            
        medicinetype: filterMedicinetype || null,        
        drugclass: search.drugClass?.trim() || null,
        type: 'catalog',
        // manufacturer: search.manufacturer?.trim() || null,
        therapeutic: search.therapeutic?.trim() || null,
        medicinename: search.medicine?.trim() || null,
        // 'medicinename': name,
        // 'modifieddate': lastUsedDate,
        'startdate': formatDate_YYYY_MM_DD(fromDate) || null,
        'enddate': formatDate_YYYY_MM_DD(toDate) || null,
        "pageno": pageno,
        pagesize
    };
    var getMedicinesList = async () => {
      try {
        var result = await FetchFilteredMedicinesList(input);

        if (result?.data) {
          setMedicineViewData(result.data);
          let count = result?.count;
          let pageno = result?.pageno;
          let pagesize = result?.pagesize;
          setTotalItemCount(count)
          let totalPagesCalc = count / pagesize;
          let totalPagesCount = Math.ceil(totalPagesCalc);
          // alert(totalPages)
          setTotalPages(totalPagesCount);
          // setFilteredData(result.data);
          setTotalItemCount(result.count)
          // if(result && result.count  < itemPerPageCommonValue){
          //   setCountTo(result.count)
          //   setTotalExceedsPageCount(true)
          // }
          if (count < itemPerPageCommonValue) {
            setCountTo(count);
            setTotalExceedsPageCount(true);
          }else if(count > itemPerPageCommonValue && pageno == 1) {
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        }else{
          setMedicineViewData([])
        }
      } catch (error) {
        console.log(error, "error in getDoctorsList");
      }
      dismissLoader();
    };

    getMedicinesList();
  };

  const handleApplyFilters = () => {
    // if(!patientName && !email && !mobile && (!plan || plan== '')){
    //   showErrorToast('Please enter the inputs to filter.')
    //   return;
    // }
    setShowFilterCount(true);
    setPageno(1)
    setCurrentPage(1)
    getFilteredResults();
  };

  const resetFields = () => {
    setName('')
    setFromDate('')
    setToDate('')
    setFromDateMinMax(null)
    setToDateMinMax(null)
    setPageno(1);
    //clear states for correct item count
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1)
    setCountTo(itemPerPageCommonValue)
    setCurrentPage(1)
    setShowFilterCount(false);
    setSearch({
      composition: '',
      dosage: '',
      type: '',
      drugClass: '',
      medicine: '',
      manufacturer: '',
      therapeutic: ''
    })
    setMedicineType("")
    setFilterMedicinetype("")
    setRefresh(!refresh);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // console.log('Enter key pressed');
      setPageno(1);
      setPagesize(itemPerPageCommonValue);
      setCountFrom(1);
      setCountTo(itemPerPageCommonValue);
      setCurrentPage(1)

      handleApplyFilters();
    }
  };

  const handleChangeName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z0-9\s@.]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setName(event.target.value);
  };

  const [search, setSearch] = useState({
    composition: '',
    dosage: '',
    type: '',
    drugClass: '',
    medicine: '',
    manufacturer: '',
    therapeutic: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearch((prev) => ({ ...prev, [name]: value }));
  };

  const handleFromDate = (selectedDate) => {
    const formattedDate = format(selectedDate, "dd-MM-yyyy");
    // console.log('formattedDAte: ', formattedDate)
    setFromDate(formattedDate);

    setFromDateMinMax(selectedDate);
  };
  const handleToDate = (selectedDate) => {
    const formattedDate = format(selectedDate, "dd-MM-yyyy");
    setToDate(formattedDate);

    setToDateMinMax(selectedDate);
  };

  // const handleLastUsedDate = (selectedDate) => {
  //   const formattedDate = format(selectedDate, "dd-MM-yyyy");
  //   // console.log('formattedDAte: ', formattedDate)
  //   setLastUsedDate(formattedDate);
  // };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // ApplyFunction();
    // handleApplyFilters()
  };



  // const ApplyFunction = async () => {
  //   if(!name &&!fromDate && !toDate){
  //     showErrorToast('Please enter the inputs to filter.')
  //     return;
  //   }
  //   showLoader();
  //   try {
  //     setPageno(1);
  //     setPagesize(itemPerPageCommonValue);
  //     setCountFrom(1);
  //     setCountTo(itemPerPageCommonValue);
  //     setCurrentPage(1)

  //     var inputForFilterDetails = {
  //       "doctorid": getLoginID(),
  //       "searchtext": name,
  //       // "modifieddate": formatDate_YYYY_MM_DD(lastUsedDate),
  //       "startdate": formatDate_YYYY_MM_DD(fromDate),
  //       "enddate": formatDate_YYYY_MM_DD(toDate),
  //       //"pageno":currentPage,
  //       "pageno":1,
  //       pagesize
  //     }

  //       const result = await FetchFilteredMedicinesList(inputForFilterDetails);
  //       // console.log(result, "APPly function result")
  //       if(result?.data){
  //         setMedicineViewData(result.data);
  //         let count = result?.count;
  //         let pageno = result?.pageno;
  //         let pagesize = result?.pagesize;

  //         let totalPagesCalc = count / pagesize;
  //         let totalPagesCount = Math.ceil(totalPagesCalc);
  //         setTotalPages(totalPagesCount)
          
  //         setTotalItemCount(result?.count)
  //         // if(result && result?.count  < itemPerPageCommonValue){
  //         //   setCountTo(result?.count)
  //         //   setTotalExceedsPageCount(true)
  //         // }
  //        // console.log(count, " count")
  //        // console.log(itemPerPageCommonValue, " itemPerPageCommonValue")
  //         if (count < itemPerPageCommonValue) {
  //           setCountTo(count);
  //           setTotalExceedsPageCount(true);
  //         }else if(count > itemPerPageCommonValue && pageno == 1) {
  //           setCountTo(itemPerPageCommonValue);
  //           setTotalExceedsPageCount(false);
  //         }
  //       } else{
  //         setMedicineViewData([])
  //       }
  //     } catch (error) {
  //       console.error('Error in ApplyFunction:', error);
  //     }
  //     dismissLoader();
  // };

  useEffect(()=>{
    if(pageno){
      
       getFilteredResults();
       }
  },[pageno])

  const handleNextClick = () => {
    let page = pageno +1 ;
  //  alert(page)
    setPageno(page);
    setCurrentPage(currentPage + 1);
   // getFilteredResults();
     
   // item count logic for next
   if(countTo + pagesize < totalItemCount){
    setCountTo(countTo + pagesize)
   }else{
     setCountTo(totalItemCount)
   }
   
   setCountFrom(countFrom + pagesize)
  };
  const handlePrevClick = () => {
    let page = pageno -1 ;
    //alert(page)
    setPageno(page);
   // setPageno(pageno - 1);
    setCurrentPage(currentPage - 1);
   // getFilteredResults();
    // item count logic for previous
    
    setCurrentPage(currentPage - 1);
    if(countTo == totalItemCount){
         //setCountTo(Math.floor(totalItemCount / 10) * 10)
       let updatedCountUnroundedValue  = totalItemCount - pagesize;
      setCountTo(Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue ) * itemPerPageCommonValue )

    }else{
      setCountTo(countTo - pagesize)
    }
    
    setCountFrom(countFrom - pagesize)
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("Do MMM, YYYY");
  };

  // ------------------------------------------------------------
  // Add medication

  const handlemedicinename = (event) => {
    setMedicineName(event.target.value);
  };

  const handleimageselection = async (e) => {
    e.preventDefault();
    setMedicineName("")
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    reader.readAsDataURL(file);
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
    dismissLoader();
      return false;
    }
    showLoader();
    const result = await GetMedicineName(file, file.name, file.type);
    if(result?.output?.message  == "No credits are available"){
      showErrorToast("No sufficient tokens available")
    }else{
    setMedicineName(result.medicine_name);
    setComposition(result.chemical_composition)

     if(result.expiry_date !== "00-0000"){
      //const formatteddate = moment(result.expiry_date).format("DD-MM-yyyy")
      setMedicineExpiryDate(result.expiry_date);
     }
    setBenifit(result.benefit);
    setSideEffects(result.side_effects);
    // showmedicinename.current.openRight();
    }
    
    
  e.target.value = '';
    dismissLoader();
  };

  // existing code function
  // const handlemedicinetypechange = (event, type) => {

  //   setMedicineType(event);
  //   if(type == "filter"){
  //     setFilterMedicinetype(event);
  //   }
  //   if(event == "Tablet" || event == "Capsule"){
  //     setMedicineDosageUnit("mg");
  //   }else if (event == "Syrup" || event == "Injection" ||  event == "Nebulization" ||  event == "IVFluids" || event == "Drops"){
      
  //     setMedicineDosageUnit("ml");
  //   }else if (event == "Ointment"){
      
  //     setMedicineDosageUnit("grms");
  //   }else if (event == "Inhaler"){
  //     setMedicineDosageUnit("puffs")
  //   }
  // };

  // newly added function
  const [showMoreTypes, setShowMoreTypes] = useState(false);
const [dropdownMedType, setDropdownMedType] = useState("");
const [selectedValue, setSelectedValue] = useState("");

const additionalMedicineTypes = [
  "Respules",
  "Suspension",
  "Foam",
  "Suppository",
  "EA",
  "Device",
  "Box",
  "Spray",
  "Lotion",
  "Tube",
  "Gargle",
  "Powder",
  "Soap",
  "Aerosol",
  "Shampoo",
  "Topical Cleanser",
  "Custom"
];

const handleDropdownMedTypeChange = (value) => {
  setMedicineType("");
  setDropdownMedType(value);
  setSelectedValue(value);
  // handlemedicinetypechange(value);
  handlemedicinetypechange(value, "dropdown");
};
  const handlemedicinetypechange = (value, source = "") => {
  console.log("Changing medicine type:", value, "from source:", source);
  
  // ALWAYS clear the opposite input
  if (source === "radio") {
    // Radio selected → clear dropdown
    setDropdownMedType(""); // THIS IS THE KEY FIX
    setMedicineType(value);
  } 
  else if (source === "dropdown") {
    // Dropdown selected → clear radio
    setMedicineType(""); // Clear radio selection
    setDropdownMedType(value);
  }
  
  // Set selected value for whatever else you need
  setSelectedValue(value);
  
  // Handle dosage units based on type
  if(value === "Tablet" || value === "Capsule" || value === "Suppository" || value === "Sachet" || value === "Powder"){
    setMedicineDosageUnit("mg");
  }
  else if (value === "Syrup" || value === "Injection" || value === "Nebulization" || value === "IV Fluids" || value === "Drops" || value === "Suspension" || value === "Respules" || value === "Gargle" || value === "Shampoo" || value === "Topical Cleanser"){
    setMedicineDosageUnit("ml");
  }
  else if (value === "Ointment" || value === "Cream" || value === "Gel" || value === "Foam" || value === "Lotion" || value === "Tube" || value === "Soap"){
    setMedicineDosageUnit("grms");
  }
  else if (value === "Inhaler" || value === "Spray" || value === "Aerosol"){
    setMedicineDosageUnit("puffs");
  }
  else if (value === "EA" || value === "Device" || value === "Box"){
    setMedicineDosageUnit("each");
  }
  else if (value === "Custom"){
    setMedicineDosageUnit("");
  }
};

  const handleChangeDosageUnit = (selectedOption) => {
    setMedicineDosageUnit(selectedOption.label);
  };

  const fetchComposition = async (medicineName) => {
    const inputData = {
      input: {
        name: medicineName,
      },
    };
    if(medicineName){
    try {
       showLoader();
      const result = await GetAIMedicineComposition(inputData.input);
      // console.log(result);
      if (result) {
        showSuccessToast("Medicine composition fetched successfully");
        setComposition(result.chemical_composition);
        setMedicineExpiryDate(result.expiry_date);
        setBenifit(result.benefit);
        setSideEffects(result.side_effects);
        if (Array.isArray(result.Manufacturer)) {
          setManufacturer(result.Manufacturer.join(", "));
        } else {
          setManufacturer(result.Manufacturer || ""); 
        }
        if (Array.isArray(result.TherapeuticCategory)) {
          setTherapeutic(result.TherapeuticCategory.join(", "));
        } else {
          setTherapeutic(result.TherapeuticCategory || "");
        }
        if (Array.isArray(result.DrugClass)) {
          setDrugClass(result.DrugClass.join(", "));
        } else {
          setDrugClass(result.DrugClass || ""); 
        }
        setInstructions(result.InstructionsOfAdministration);
      }
      dismissLoader()
    } catch (error) {
      console.error("Error Fetching Medicine composition:", error);
      showErrorToast("An error occurred while Fetching Medicine composition");
    } 
      
  }else{
    showErrorToast("Please provide medicine name or upload medicine photo")
  }
  };
  const fetchEditComposition = async (medicineName) => {
    const inputData = {
      input: {
        name: medicineName,
      },
    };
    if(medicineName){
    try {
       showLoader();
      const result = await GetAIMedicineComposition(inputData.input);
      // console.log(result);
      if (result) {
        showSuccessToast("Medicine composition fetched successfully");
        setComposition(result.chemical_composition);
        setMedicineExpiryDate(result.expiry_date);
        setBenifit(result.benefit);
        setSideEffects(result.side_effects);
        if (Array.isArray(result.Manufacturer)) {
          setManufacturer(result.Manufacturer.join(", "));
        } else {
          setManufacturer(result.Manufacturer || ""); 
        }
        if (Array.isArray(result.TherapeuticCategory)) {
          setTherapeutic(result.TherapeuticCategory.join(", "));
        } else {
          setTherapeutic(result.TherapeuticCategory || "");
        }
        if (Array.isArray(result.DrugClass)) {
          setDrugClass(result.DrugClass.join(", "));
        } else {
          setDrugClass(result.DrugClass || ""); 
        }
        setEditInstructions(result.InstructionsOfAdministration);
      }
      dismissLoader()
    } catch (error) {
      console.error("Error Fetching Medicine composition:", error);
      showErrorToast("An error occurred while Fetching Medicine composition");
    } 
      
  }else{
    showErrorToast("Please provide medicine name or upload medicine photo")
  }
  };

  // const handleFrequencyValue = (selectedOption) => {
  //   setMedicineDosageFrequency(selectedOption)
  //   // if(selectedOption == "1"){
  //   //   setMedicineDosageFrequency("1");
  //   // }else  if(selectedOption == "2"){
  //   //   setMedicineDosageFrequency("2");
  //   // }else  if(selectedOption == "3"){
  //   //   setMedicineDosageFrequency("3");
  //   // }else  if(selectedOption == "4"){
  //   //   setMedicineDosageFrequency("4");
  //   // }
  // };

  const handleExpiryDateChange = (event) => {
    //const formattedDate = moment(selecteddate).format('YYYY-MM-DD');
    setMedicineExpiryDate(event);
  };

  // const handlemedicinetime = (values) => {
  //   if (values.includes("morning")) {
  //     setMorning(1);
  //   } else {
  //     setMorning(0);
  //   }

  //   if (values.includes("afternoon")) {
  //     setAfternoon(1);
  //   } else {
  //     setAfternoon(0);
  //   }
  //   if (values.includes("evening")) {
  //     setEvening(1);
  //   } else {
  //     setEvening(0);
  //   }
  
  //   if (values.includes("night")) {
  //     setNight(1);
  //   } else {
  //     setNight(0);
  //   }
  // };

  // const handlemedicinetimebeforeafter = (values) => {
  //   if (values.includes("beforefood")) {
  //     setBeforefood(1);
  //   } else {
  //     setBeforefood(0);
  //   }
  
  //   if (values.includes("afterfood")) {
  //     setAfterfood(1);
  //   } else {
  //     setAfterfood(0);
  //   }
  // };

  // const [timeValues, setTimeValues] = useState([]);
              // const [foodTiming, setFoodTiming] = useState(""); 
  
              const handlemedicinetime = (values) => {
                
                // If any time checkbox is selected, clear frequency inputs
                if (values.length > timeValues.length) {
                  // if (values.length > 0) {
                    setMedicineFreqUnit("");
                    setMedicineFreqValue("");
                    // setMedicineFreqValue(null);
                  }
                  setTimeValues(values);
                
                // Update individual time states if needed
                setMorning(values.includes("morning") ? 1 : 0);
                setAfternoon(values.includes("afternoon") ? 1 : 0);
                setNight(values.includes("night") ? 1 : 0);
              };
              
  const handlemedicinetimebeforeafter = (value) => {
    setFoodTiming(value);
    if (value === "beforefood") {
      setBeforefood(1);
      setAfterfood(0);
    } else {
      setBeforefood(0);
      setAfterfood(1);
    }
  };

  const handleSurgeonNameChange = (surgeonName) => {
    let formattedValue = surgeonName.replace(/[^0-9a-zA-Z\s.]/g, "")
    setPrescribedBy(formattedValue);

    // Filter surgeon names based on input
    if (formattedValue) {
      filterSurgeonNames(formattedValue);
    } else {
      setSuggestions([]);
    }
    setPrescribedBy(formattedValue)
  };

  const filterSurgeonNames = (surgeonName) => {
    const filtered = treatmentteamdata && treatmentteamdata.filter((surgeon) =>
      surgeon.doctorname?.toLowerCase().includes(surgeonName.toLowerCase())
    );
    setSuggestions(filtered);
  };

  const listOfSurgeonNames = ( isImage) => {
 
    const allSuggestions = treatmentteamdata && treatmentteamdata
  
    setSuggestions(allSuggestions);
    // setBoolValForSuggestions(!boolValForSuggestions) 
    if(isImage){
      setShowDocNamesDropdown(!showDocNamesDropdown)
  
    }
  };

  const handleSelect = (suggestion) => {
    setPrescribedBy(suggestion.doctorname);
    setSuggestions([]);
  };

  const handleIsCurrent = (e)=>{
    if(e.target.checked){
      setIsChecked(1)
    }else{
      setIsChecked(0)
    }
  }

  const handleDelete = (index) => {
    const newArray = [...filenameArray];
    newArray.splice(index, 1);
    setFilenameArray(newArray);
  };

  const addMedicationUploadDocument = () => {
    fileInputRef.current.click();
  }

  const handleMedicationUpload = async (e) => {
    e.preventDefault();
    showLoader();

    const file2 = e.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file2.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
      setTimeout(() => {
        
        dismissLoader();
      }, 1000);
      return false;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file2);
    //console.log(file2 , "File")
    const result = await uploadImageInProfile(file2, file2.name);
    //console.log(result , "result.name ");
    const filename = result.name;
    setFilenameArray(prev => [...prev, filename]);
    
    e.target.value = ''; 
    dismissLoader();

  };

  const fetchAiDoctorPrompts = async (medicinename)=>{
    showLoader();
    setRemainingQuestions([])
    setAiInput(null);
    setAIAnswers([])
    setInitialRender(true)
    const result = await FetchMyHealthAIData({
      // patientid,
    });
    // console.log(result)
    let Aiprompts = { ...result, medicinename };
      setAiInput(Aiprompts);
      const response = await FetchMedicineAIPrompts(Aiprompts);
      if (response.generated_question) {
        setAIAnalysis(response);
        setRemainingQuestions(response.generated_question);
        AIChatModel.current.openRight();
      }
      dismissLoader();
  }


  let input = {
    doctorid: "",
    medicinedetail: [
      {
        medicinename: medicinename,
        chemical_composition: Composition,
        medicinetype: medicinetype || "Tablet",
        dosage: dosage,
        dosageunit:dosageunit,
        // startdate: fromdate,
        // enddate: todate,
        // frequency:   frequency && medicineFreqUnit ? (frequency + " " + medicineFreqUnit) : frequency,
        frequency: frequency || "1",
        frequencytime: medicineFreqUnit,
        frequencyvalue: medicineFreqValue || null,
        morning: morning,
        afternoon: afternoon,
        evening: setevening,
        night: setnight,
        beforefood: beforefood,
        afterfood: afterfood,
        medicineexpirydate: medicineexpirydate,
        iscurrentmedicine: isChecked,
        longtext: "",
        documents: filenameArray.map(filename => ({ filename })),

        // new inputs
        "routeofadministration": routeOfAdministration,
        "timingofinjection": timing,
        "quantitytobeapplied": quantity,
        "wheretoapply": areaOfApplication,
        "applicationtiming": foodTiming,
        "diluent": diluent,
        "additives": additives,

        "rateofinfusionvalue": rateOfInfusionValue,
        "rateofinfusionunit": rateOfInfusionUnit,
        // "duration": durationValue && durationUnit ? (durationValue + " " + durationUnit) : durationValue,
        "duration": durationValue && durationUnit ? (durationValue + " " + durationUnit) : durationValue || "5 Days",
        "drugclass": drugClass,
        "therapeutic": therapeutic,
        "manufacturer": manufacturer,
        "instructions": instructions,
        // "custommessage":customMessage,
        // "sos":sos
      
      },

    ],
  };

  const addmedicine = async () => {
    showLoader();
    if (moment(input.medicinedetail[0].startdate, 'DD-MM-YYYY', true).isValid()) {
    input.medicinedetail[0].startdate = moment(input.medicinedetail[0].startdate, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
    if (moment(input.medicinedetail[0].enddate, 'DD-MM-YYYY', true).isValid()) {
    input.medicinedetail[0].enddate = moment(input.medicinedetail[0].enddate, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
    
    //Freq and duration validations in Add Func ---
      // if (medicineFreqUnit && !frequency) {
      //   showErrorToast("Please select Frequency!");
      //   dismissLoader();
      //   return false;
      // } 
      // else if (!medicineFreqUnit && frequency) {
      //   showErrorToast("Please select Frequency Interval!");
      //   dismissLoader();
      //   return false;
      // } 
      if (medicineFreqUnit && !medicineFreqValue) {
        showErrorToast("Please select Frequency Value!");
        dismissLoader();
        return false;
      } else if (!medicineFreqUnit && medicineFreqValue) {
        showErrorToast("Please select Frequency!");
        dismissLoader();
        return false;
      }
      else if (!durationUnit && durationValue  && (medicinetype != "Syrup" && medicinetype != "Drops")) {
        showErrorToast("Please select Duration!");
        dismissLoader();
        return false;
      } else if (durationUnit && !durationValue  && (medicinetype != "Syrup" && medicinetype != "Drops")) {
        showErrorToast("Please select Interval Value!");
        dismissLoader();
        return false;
      }
    // Required fields validation
    if (!Composition || Composition.trim() === "") {
      showErrorToast("Please enter Medicine Composition");
      dismissLoader();
      return false;
    }
    if (!dosage && dosage !== 0) {
      showErrorToast("Please enter Strength");
      dismissLoader();
      return false;
    }
    if (!(medicinetype || dropdownMedType)) {
      showErrorToast("Please select Medicine Type");
      dismissLoader();
      return false;
    }
    if (!drugClass || drugClass.trim() === "") {
      showErrorToast("Please enter Drug Class");
      dismissLoader();
      return false;
    }

    //---

    if (medicinename == "") {
      showErrorToast("Please specify or upload any medicine");
      setTimeout(() => {
      dismissLoader();
      }, 1000);
      return false;
    } else {
      const result = await AddMedicine(input);
      
      if (result && result.output.result === 'success') {
        // if(showAIModal){
        //   await fetchAiDoctorPrompts(medicinename);
        // }
        showSuccessToast("Medicine created Successfully");
        // FetchData(medicinetypeFilter, activeTab === 1? "0": "1");
        addmedications.current.closeModal();
  setIsAddModalOpen(false);
        // fetchMedicinesView();
        // getMedicinesList();

        getFilteredResults();
      } else if (result.output.result === "failure" && result.output.message ==="medicine already Exists") {
        showErrorToast("Medicine already Exists")
      }
    }
    dismissLoader();
  };

  const makeAicall = async ()=>{
    const inputData = {
      input: {
        name: medicinename,
      },
    };
    if(medicinename){
    try {
     showLoader();
    const result = await GetAIMedicineComposition(inputData.input);
    if(result){
        // setMedicineName(result.medicine_name);
        setComposition(result.chemical_composition)

        if(result.expiry_date !== "00-0000"){
          //const formatteddate = moment(result.expiry_date).format("DD-MM-yyyy")
          setMedicineExpiryDate(result.expiry_date);
        }
        setBenifit(result.benefit);
        setSideEffects(result.side_effects);
        learnMoreModal.current.openModal()
         dismissLoader();
    }
    }catch(error){

    }
  }
};

function clearState (){
  setRouteOfAdministration(null);
  setTiming(null);
  setQuantity(null);
  setAreaOfApplication(null);
  setDiluent(null);
  setInfusionDuration(null);
  setAdditives(null);
  setDuration(null)
  setMedicineFreqValue(null); 
  setMedicineFreqUnit(null); 
  setRateOfInfusionValue(null);
  setRateOfInfusionUnit("ml/hr")
  
  setDurationValue("3"); 
  setDurationUnit("Days"); 

  setCustomMessage(null);
  setSOS(null);
}

const addData = () => {
  setFilenameArray([]);
  setMedicineName("") 
  setComposition("") 
  // setFromDate(moment().format("DD-MM-yyyy"))
  // setToDate(moment().format("DD-MM-yyyy"))
  setHospitalname(null)
  setPrescribedBy(null)
  setMedicineType("Tablet")
  setDropdownMedType("")
  setMedicineDosageUnit("mg")
  setMedicineDosage(null)
  setMedicineDosageFrequency("1")
  setMorning("1")
  setEvening("0")
  setAfternoon("0")
  setNight("0")
  // Default to AFTER food now
  setBeforefood('0')
  setAfterfood('1')
  setMedicineFreqUnit("")
  setMedicineFreqValue(null)
  setComposition("")
  setTimeValues(["morning"]);
  // Clear Application Timing for Add modal; user must choose explicitly
  setFoodTiming("");
  setMedicineExpiryDate("")
  setDrugClass("");
  setManufacturer("");
  setTherapeutic("");
  setInstructions("");
  setShowAIModal(true)

  clearState();
  // addmedications.current.openRight()
  setIsAddModalOpen(true);
  addmedications.current.openModal()
  setShowDocNamesDropdown(false)
 
}
// const addData = () => {
//   setFilenameArray([]);
//   setMedicineName("") 
//   setComposition("") 
//   // setFromDate(moment().format("DD-MM-yyyy"))
//   // setToDate(moment().format("DD-MM-yyyy"))
//   setHospitalname(null)
//   setPrescribedBy(null)
//   setMedicineType("Tablet")
//   setDropdownMedType("")
//   setMedicineDosageUnit("mg")
//   setMedicineDosage(null)
//   setMedicineDosageFrequency("1")
//   setMorning("1")
//   setEvening("0")
//   setAfternoon("0")
//   setNight("0")
//   setBeforefood('1')
//     setAfterfood('0')
//     setMedicineFreqUnit("")
//     setMedicineFreqValue(null)
//   setComposition("")
//   setTimeValues(["morning"]);
//   setFoodTiming("beforefood");
//   setMedicineExpiryDate("")
//   setDrugClass("");
//   setManufacturer("");
//   setTherapeutic("");
//   setInstructions("");
//   setShowAIModal(true)

//   clearState();
//   // addmedications.current.openRight()
//   setIsAddModalOpen(true);
//   addmedications.current.openModal()
//   setShowDocNamesDropdown(false)
 
// }

// --------------------------------------------
// AIChatModel

const GetAIAnswer = async (prompt) => {
  // Display question immediately
  const newQuestion = { question: prompt, answer: "" };
  setAIAnswers((prevState) => [...prevState, newQuestion]);

  // Remove the question from remaining questions immediately
  setRemainingQuestions((prevState) => prevState.filter((question) => question.value !== prompt));

  // Trigger animation
  setAnimate(true);

  // Set initialRender to false after the first question is clicked
  setInitialRender(false);
  let AichatInput = { ...AiInput, query:prompt };


  const response = await FetchMedicineAIAnswer(AichatInput);

  if (response) {
    // Replace "typing" with actual answer
    setAIAnswers((prevState) =>
      prevState.map((item) =>
        item.question === prompt && item.answer === ""
          ? { question: item.question, answer: response.answer }
          : item
      )
    );
  }
};

// ------------------------------------------------------------
// Add To Favourite medication
const [currentItem, setCurrentItem] = useState(null); 
const [isAddingToFav, setIsAddingToFav] = useState(true);

const handlefavouritemedication = async (item) => {
  console.log(item, " favourite item ");
  setCurrentItem(item);
  // setMedicineName(item.medicinename);
  setMedicineName(formatMedicineName(item))

  // Check if medicine is already in favorites
  if (item.fav == 1) {
    setIsAddingToFav(false);
  } else {
    setIsAddingToFav(true);
  }
  
  favouritemedications.current.openModal();
};

// Save Medicine call
const handleSaveFavouriteMedicine = async () => {
  if (!currentItem) {
    showErrorToast("No medicine selected");
    return;
  }

  const input = {
    doctorid: "", 
    type: "favourite",
    medicinedetail: [
      {
        medicinename: currentItem.medicinename,
        chemical_composition: currentItem.chemicalcomposition,
        medicinetype: currentItem.medicinetype,
        dosage: currentItem.dosage,
        dosageunit: currentItem.dosageunit,
        frequency: currentItem.frequency,
        frequencytime: currentItem.frequencytime,
        frequencyvalue: currentItem.frequencyvalue,
        morning: currentItem.morning?.toString() || "0",
        afternoon: currentItem.afternoon?.toString() || "0",
        evening: currentItem.evening?.toString() || "0",
        night: currentItem.night?.toString() || "0",
        beforefood: currentItem.beforefood?.toString() || "0",
        afterfood: currentItem.afterfood?.toString() || "0",
        iscurrentmedicine: currentItem.iscurrentmedicine || 0,
        documents: [],
        routeofadministration: currentItem.routeofadministration || null,
        timingofinjection: currentItem.timingofinjection || null,
        quantitytobeapplied: currentItem.quantitytobeapplied || null,
        areaofapplication: currentItem.areaofapplication || null,
        diluent: currentItem.diluent || null,
        additives: currentItem.additives || null,
        rateofinfusionvalue: currentItem.rateofinfusionvalue || null,
        rateofinfusionunit: currentItem.rateofinfusionunit || null,
        duration: currentItem.duration || "5 Days",
        drugclass: currentItem.drugclass || null,
        therapeutic: currentItem.therapeutic || null,
        manufacturer: currentItem.manufacturer || null,
        instructions: currentItem.instructions || "",
      },
    ],
  };

  console.log("Sending to API:", input);

  try {
    showLoader(); 
    const result = await AddMedicine(input); 
    
    if (result && result.output && result.output.result === "success") {
      showSuccessToast(`${currentItem.medicinename} added to favourites successfully`);
      console.log("Successfully added to favorites:", result);
      setCurrentItem(null);
      getFilteredResults();
      
      favouritemedications.current.closeModal();
    } else if (result && result.output && result.output.result === "failure") {
      showErrorToast(result.output.message || "Failed to add medicine to favorites");
      console.error("Failed to add to favorites:", result.output.message);
    }
  } catch (error) {
    console.error("Error adding medicine to favorites:", error);
    showErrorToast("Error adding medicine to favorites");
  } finally {
    dismissLoader(); 
  }
};

// Remove from favorites (Delete call)
const handleRemoveFavouriteMedicine = async () => {
  if (!currentItem) {
    showErrorToast("No medicine selected");
    return;
  }

  try {
    showLoader(); 
    const result = await DeleteMedication({
      "loginid": getLoginID(),
      "id": currentItem.id, 
      "type": "removefavourite"
    });
    
    if (result.output.result == "Successfully Deleted") {
      showSuccessToast(`${currentItem.medicinename} removed from favourites`);
      getFilteredResults();
      // // Update the medicine object in your state to set fav = 0
      // setMedicines(prevMedicines => 
      //   prevMedicines.map(med => 
      //     med.id === currentItem.id 
      //       ? { ...med, fav: 0 } 
      //       : med
      //   )
      // );
      
      // // Remove from selected favorites
      // setSelectedFavouriteItems(selectedFavouriteItems.filter(id => id !== currentItem.id));
      
      setCurrentItem(null);
      favouritemedications.current.closeModal();
    } else {
      showErrorToast("Failed to remove medicine from favourites");
      console.error("Failed to remove from favorites:", result.output.message);
    }
  } catch (error) {
    console.error("Error removing medicine from favorites:", error);
    showErrorToast("Error removing medicine from favorites");
  } finally {
    dismissLoader(); 
  }
};

// Combined handler for modal button
const handleFavouriteAction = () => {
  if (isAddingToFav) {
    handleSaveFavouriteMedicine();
  } else {
    handleRemoveFavouriteMedicine();
  }
};

// ------------------------------------------------------------
  // Edit medication

  const handleeditmedication = (item)=>{
    // log full object including our new fields
    console.log({
      ...item,
      wheretoapply: item.wheretoapply,
      applicationtiming: item.applicationtiming,
      quantitytobeapplied: item.quantitytobeapplied,
      quantity: item.quantity
    }, " edit modal item ")
    setID(item.id);
    setMedicineName(item.medicinename);
    setComposition(item.chemicalcomposition);
    setEditInstructions(item.instructions);
    // setMedicineType(item.medicinetype);
    // setDropdownMedType(item.medicinetype);
    // Set the initial selection
  if (additionalMedicineTypes.includes(item.medicinetype)) {
    setDropdownMedType(item.medicinetype);
    setSelectedValue(item.medicinetype);
    setMedicineType("");
  } else {
    setMedicineType(item.medicinetype);
    setDropdownMedType("");
    setSelectedValue("");
    // setSelectedValue(item.medicinetype);
  }
    setMedicineDosage(item.dosage);
    setMedicineDosageUnit(item.dosageunit);
    setMedicineDosageFrequency(item.frequency);
    setMedicineFreqUnit(item.frequencytime)
    setMedicineFreqValue(item.frequencyvalue)
    // const stratdate =  moment(item.medicationstartdate, 'YYYY-MM-DD').format('DD-MM-yyyy');
    // const enddate =  moment(item.medicationenddate, 'YYYY-MM-DD').format('DD-MM-yyyy');
    // setFromDate(stratdate)
    // setToDate(enddate);
    setMorning(item.morning);
    setEvening(item.evening);
    setAfternoon(item.afternoon);
    setNight(item.night);
    setBeforefood(item.beforefood);
    setAfterfood(item.afterfood);
    setPrescribedBy(item.prescribedby)
    setHospitalname(item.prescribedhospitalname)
    // setIsChecked(item.iscurrentmedicine)
    setIsChecked(item.iscurrentmedicine === "Current" ? 1 : 0);
    setMaxDateStateEdit("")
    setMinDateStateEdit("")
    setMedicineExpiryDate(item.medicineexpirydate)
    setShowDocNamesDropdown(false)
    setShowAIModal(true)

    // new Input states set on Edit modal open - Start ||----
    setRouteOfAdministration(item.routeofadministration);
    setTiming(item.timingofinjection);
    // support alternate quantity property names
    setQuantity(item.quantitytobeapplied ?? item.quantity ?? null);
    setAreaOfApplication(item.wheretoapply || item.areaofapplication);
    setDiluent(item.diluent);
    setInfusionDuration(item.infusionDuration);
    setAdditives(item.additives);
    
    setRateOfInfusionUnit(item.rateofinfusionunit)
    setRateOfInfusionValue(item.rateofinfusionvalue)

    setDuration(item.duration);
    setDrugClass(item.drugclass);
    setManufacturer(item.manufacturer);
    setTherapeutic(item.therapeutic);
    // setInstructions(item.instructions);
    setTimeValues([
      item.morning ? "morning" : null,
      item.afternoon ? "afternoon" : null,
      item.night ? "night" : null,
    ])
    setMedicineTypeRadio(item.medicinetype)
    setFoodTiming(item.applicationtiming || (item.beforefood ? "beforefood" : "afterfood"))
    // setMedicineDosageFrequency(item.frequency);

    if (item.duration) {
      const parts = item.duration.split(" "); 
      const value = parts[0]; 
      const unit = parts[1];  
      // setMedicineFreqValue(value); 
      // setMedicineFreqUnit(unit);  
      setDurationValue(value); 
      setDurationUnit(unit);  
    }

    // if (item.frequency) {
    //   const parts = item.frequency.split(" "); 
    //   const value = parts[0]; 
    //   const unit = parts[1];  
    //   setMedicineDosageFrequency(value); 
    //   setMedicineFreqUnit(unit);  
    // }

    // if (item.duration) {
    //     const parts = item.duration.split(" "); 
    //     const value = parts[0]; 
    //     const unit = parts[1];  
    //     setDurationValue(value); 
    //     setDurationUnit(unit);  
    //   }

      // setSOS(item.sos)
      // setCustomMessage(item.custommessage)
    // new Input states set on Edit modal open - End ----||

  setIsEditModalOpen(true)
    editmedications.current.openModal();
  }

  // Update data
  const editmedicine = async () => {
    let input = {
      'doctorid': getLoginID(),
      "id": id,
      documenttype_cd: "",
      documentcategory_cd: "",
      documentname: "",
      documenturl: "",
      prescribedby: prescribedby,
      hospitalname: hospitalname,
      // patientname: patientname,
      // age: age,
      documentdate: today,
      medicinename: medicinename,
      chemical_composition: Composition,
      medicinetype: medicinetype ? medicinetype : dropdownMedType,
      dosage: dosage,
      dosageunit:dosageunit,
      // startdate: fromdate,
      // enddate: todate,
      // frequency:   frequency && medicineFreqUnit ? (frequency + " " + medicineFreqUnit) : frequency,
      frequency: frequency,
      morning: morning,
      afternoon: afternoon,
      evening: setevening,
      night: setnight,
      beforefood: beforefood,
      afterfood: afterfood,
      medicineexpirydate: medicineexpirydate,
      iscurrentmedicine: isChecked,
      longtext: "",

      documents: filenameforUpload.map(filename => ({ filename })),

       // new inputs
       "routeofadministration": routeOfAdministration,
       "timingofinjection": timing,
       "quantitytobeapplied": quantity,
       "wheretoapply": areaOfApplication,
       "applicationtiming": foodTiming,
       "diluent": diluent,
       "additives": additives,
       
       "rateofinfusionvalue": rateOfInfusionValue,
       "rateofinfusionunit": rateOfInfusionUnit,
       "duration": durationValue && durationUnit ? (durationValue + " " + durationUnit) : durationValue,
        "drugclass": drugClass,
        "therapeutic": therapeutic,
        "manufacturer": manufacturer,
        // "instructions": instructions,
        "instructions": editInstructions,
      //  "custommessage":customMessage,
      //   "sos":sos
    };
    if (moment(input.startdate, 'DD-MM-YYYY', true).isValid()) {
      input.startdate = moment(input.startdate, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
    if (moment(input.enddate, 'DD-MM-YYYY', true).isValid()) {
      input.enddate = moment(input.enddate, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
   
    //Freq and duration validations ---
      if (medicineFreqUnit && !frequency) {
        showErrorToast("Please select Frequency!");
        dismissLoader();
        return false;
      } 
      // else if (!medicineFreqUnit && frequency) {
      //   showErrorToast("Please select Frequency Interval!");
      //   dismissLoader();
      //   return false;
      // } 
      else if (!durationUnit && durationValue  && (medicinetype != "Syrup" && medicinetype != "Drops")) {
        showErrorToast("Please select Duration!");
        dismissLoader();
        return false;
      } else if (durationUnit && !durationValue  && (medicinetype != "Syrup" && medicinetype != "Drops")) {
        showErrorToast("Please select Interval Value!");
        dismissLoader();
        return false;
      }
    //--- Required fields validation
    if (!Composition || Composition.trim() === "") {
      showErrorToast("Please enter Medicine Composition");
      return false;
    }
    if (!dosage && dosage !== 0) {
      showErrorToast("Please enter Strength");
      return false;
    }
    if (!(medicinetype || dropdownMedType)) {
      showErrorToast("Please select Medicine Type");
      return false;
    }
    if (!drugClass || drugClass.trim() === "") {
      showErrorToast("Please enter Drug Class");
      return false;
    }

    if (medicinename == "") {
      showErrorToast("Please specify or upload any medicine");
      return false;
    } else {
     
      showLoader();
      const result = await EditMedicine(input);
      
      if (result) {
        // if(showAIModal){
        // await fetchAiDoctorPrompts(input.medicinename);
        // }
        showSuccessToast("Medicine updated Successfully");
        fetchData(medicinetypeFilter, activeTab === 1? "0": "1");
        // getFilteredResults()
        setRefresh(!refresh);
        editmedications.current.closeModal();
  setIsEditModalOpen(false)
        // detailsmodel.current.closeRight();
        
      }
      setTimeout(() => {
        
      dismissLoader();
      }, 2000);
    }
  };

  const updateMedicationDocuments = () => {

    fileInputRefUpdate.current.click();
  }

  const handleMedicationUploadUpdate = async (e) => {
    e.preventDefault();
    showLoader();

    const file2 = e.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file2.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
      setTimeout(() => {
        
        dismissLoader();
      }, 1000);
      return false;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file2);
    
    const result = await uploadImageInProfile(file2, file2.name);
 
    const filename = result.name;
    // setMedicineData(prevData => [...prevData, filename]);
    setFilenameforUpload(prevFilenames => [...prevFilenames, filename]);
    //console.log(filenameforUpload, "filenameforUpload")

    // below we are setting the documents uploaded in edit, and we are checking if the prevFileNames is an array or not
    //  as when prevFileNames is empty it is giving error that iprevFileNames is not an array.
    setDocumentURLForEdit(prevFileNames => {
      if(!Array.isArray(prevFileNames)){
        return[{
          documentname: filename,
          documenturl: filename,
          imagepath: "https://midocfileserver.blob.core.windows.net/midocdev/"
        }]
      }else {
        return[
          ...prevFileNames, 
          {
            documentname: filename,
            documenturl: filename,
            imagepath: "https://midocfileserver.blob.core.windows.net/midocdev/"
       
          }
        ]
      }
    })
    showSuccessToast("Document Added Successfully.");
    e.target.value = '';
    dismissLoader();

  };

  const handleDeleteDocInEdit = (index) => {
    const updatedUrls = [...documentURLForEdit];
    updatedUrls.splice(index, 1);
   // setUploadedDocuments(updatedUrls);
    
    setDocumentURLForEdit(updatedUrls);

    if (updatedUrls != null) {

      setFilenameforUpload(updatedUrls?.map(doc => doc.documentname));
    }
  };

  const DeleteMedicineModel = (title, id) => {
    setID(id);
    setTitle(title);
    dynamicModal.current.openModal();
  };

  const deletemedicine = async () => {
    const result = await DeleteMedicine({
      // loginid,
      // id: id,
    });
    if (result) {
      showSuccessToast("Medicine deleted successfully");
      fetchData(medicinetypeFilter,activeTab === 1? "0": "1");
      dynamicModal.current.closeModal();
      detailsmodel.current.closeRight();
    }
  };

  const fetchData = async (type, tab) => {
    showLoader();
    setData("");
    try {
      const result = await FetchMedicationsData({
        // patientid,
        doctorid: getLoginID(),
        medicinetype: type,
        // iscurrent: tab,
      });
      //console.log(result, "modified medications res");
      if (result != null) {
        setData(result);
      } else {
        //alert("No data");
      }
      dismissLoader();
    } catch (error) {
      console.error("Error in DashboardIndex:", error);
    }
  };

  useEffect(()=>{
    if(!medicinename){
      setComposition("")
    }
  },[medicinename])

  // new input fields added functionality || start 

  const handleRateOfInfusionUnit = (selectedOption) => {
    setRateOfInfusionUnit(selectedOption.label);
  };

  // function handleFrequencyUnit(selectedOption) {
  //     setMedicineFreqUnit(selectedOption)
  // }
  function handleFrequencyUnit(selectedOption) {
                 
    if (selectedOption) {
      setTimeValues([]);
      setMorning(0);
      setAfternoon(0);
      setNight(0);
     }
     setMedicineFreqUnit(selectedOption)
 }
  function handleFrequencyValue(selectedOption) {
    
    // If frequency value is selected, clear time checkboxes
    if (selectedOption) {
      setTimeValues([]);
      setMorning(0);
      setAfternoon(0);
      setNight(0);
     }
     setMedicineFreqValue(selectedOption)
 }

 const handleEditFrequencyUnit = (selectedOption) => {
  // Clear time checkboxes when frequency unit is selected
  setTimeValues([]);
  setMorning(0);
  setAfternoon(0);
  setNight(0);
  setMedicineFreqUnit(selectedOption);
};
const handleEditFrequencyValue = (selectedOption) => {
  // Clear time checkboxes when frequency value is selected
  setTimeValues([]);
  setMorning(0);
  setAfternoon(0);
  setNight(0);
  setMedicineFreqValue(selectedOption);
};

  function handleDurationValue(selectedOption) {
      setDurationValue(selectedOption)
  }
  function handleDurationUnit(selectedOption) {
    // if(selectedOption != "Until symptoms resolve"){
      setDurationUnit(selectedOption)
    // }
  }

  function handleRouteOfAdministration(selectedOption) {
    setRouteOfAdministration(selectedOption)
  }
  
  function handleTiming(e) {
    setTiming(e.target.value)
  }
  
  function handleQuantity(selectedOption) {
    setQuantity(selectedOption)
  }
  
  function handleAreaOfApplication(e) {
    setAreaOfApplication(e.target.value)
  }
  function handleDrugClass(e) {
    setDrugClass(e.target.value)
  }
  function handleTherapeuticCategory(e) {
    setTherapeutic(e.target.value)
  }
  function handleManufacturer(e) {
    setManufacturer(e.target.value)
  }
  function handleInstructions(value) {
    // console.log('e: ', e.target.value)
    setInstructions(value)
  }
  function handleEditInstructions(value) {
    // console.log('e: ', e.target.value)
    setEditInstructions(value)
  }
  
  function handleDiluent(selectedOption) {
    setDiluent(selectedOption)
  }
  
  function handleInfusionDuration(selectedOption) {
    setInfusionDuration(selectedOption)
  }
  function handleInfusionFrequency(selectedOption) {
    setInfusionFrequency(selectedOption)
  }
  
  function handleAdditives(e) {
    setAdditives(e.target.value)
  }

  function handleSOS(e) {
    setSOS(e.target.value)
  } 
  function handleCustomMessage(e) {
    setCustomMessage(e.target.value)
  }
  
  // new input fields added functionality End ||

  // --------------------------------------------------------------------
// Delete functionality
const [medicineId, setMedicineId] = useState(null);
const [medName, setMedName] = useState(null);

const openDeleteModal = (id, medicine) => {
  // console.log('id: ', id)
  setMedicineId(id);
  setMedName(formatMedicineName(medicine))

    dynamicModal.current.openModal();
};

const deleteMedicine = async () => {
  const result = await DeleteMedication({
    "loginid": getLoginID() ,
    "id": medicineId,
  });
  if (result.output.result == "Successfully Deleted") {
    showSuccessToast("Medicine deleted successfully");
    dynamicModal.current.closeModal();
    // getFilteredResults();
    setRefresh(!refresh);
  }
};

const fetchDisplayComposition = async (medicineid, medicineName) => {
  // if(medicineid && medicineName){
  //   setMedicineName(medicineName)
  //   setID(medicineid)
  // }
  const inputData = {
    input: {
      name: medicineName,
    },
  };
  if(medicineName){
  try {
     showLoader();
    const result = await GetAIMedicineComposition(inputData.input);
    // console.log(result);
    if (result) {
      showSuccessToast("Medicine composition fetched successfully");
      setComposition(result.chemical_composition);
      setMedicineExpiryDate(result.expiry_date);
      setBenifit(result.benefit);
  setSideEffects(result.side_effects);
  await editCompMedicine(result.chemical_composition, medicineid, medicineName);
  // setID("")
  // setMedicineName('')
    }
    dismissLoader()
  } catch (error) {
    console.error("Error Fetching Medicine composition:", error);
    showErrorToast("An error occurred while Fetching Medicine composition");
  } 
    
}else{
  showErrorToast("Please provide medicine name or upload medicine photo")
}
};

const editCompMedicine = async (chemComp, medId, medName) => {
  let input = {
    'doctorid': getLoginID(),
    "id": medId,
    documenttype_cd: "",
    documentcategory_cd: "",
    documentname: "",
    documenturl: "",
    prescribedby: prescribedby,
    hospitalname: hospitalname,
    // patientname: patientname,
    // age: age,
    documentdate: today,
    medicinename: medName,
    chemical_composition: chemComp,
    medicinetype: medicinetype,
    dosage: dosage,
    dosageunit:dosageunit,
    // startdate: fromdate,
    // enddate: todate,
    frequency:   frequency && medicineFreqUnit ? (frequency + " " + medicineFreqUnit) : frequency,
    morning: morning,
    afternoon: afternoon,
    evening: setevening,
    night: setnight,
    beforefood: beforefood,
    afterfood: afterfood,
    medicineexpirydate: medicineexpirydate,
    iscurrentmedicine: isChecked,
    longtext: "",

    documents: filenameforUpload.map(filename => ({ filename })),

     // new inputs
     "routeofadministration": routeOfAdministration,
     "timingofinjection": timing,
     "quantitytobeapplied": quantity,
     "wheretoapply": areaOfApplication,
     "applicationtiming": foodTiming,
     "diluent": diluent,
     "additives": additives,
     
     "rateofinfusionvalue": rateOfInfusionValue,
     "rateofinfusionunit": rateOfInfusionUnit,
     "duration": durationValue && durationUnit ? (durationValue + " " + durationUnit) : durationValue,
    
    //  "custommessage":customMessage,
    //   "sos":sos
  };
  if (moment(input.startdate, 'DD-MM-YYYY', true).isValid()) {
    input.startdate = moment(input.startdate, 'DD-MM-YYYY').format('YYYY-MM-DD');
  }
  if (moment(input.enddate, 'DD-MM-YYYY', true).isValid()) {
    input.enddate = moment(input.enddate, 'DD-MM-YYYY').format('YYYY-MM-DD');
  }
 
  //Freq and duration validations ---
    if (medicineFreqUnit && !frequency) {
      showErrorToast("Please select Frequency!");
      dismissLoader();
      return false;
    } 
    // else if (!medicineFreqUnit && frequency) {
    //   showErrorToast("Please select Frequency Interval!");
    //   dismissLoader();
    //   return false;
    // } 
    else if (!durationUnit && durationValue  && (medicinetype != "Syrup" && medicinetype != "Drops")) {
      showErrorToast("Please select Duration!");
      dismissLoader();
      return false;
    } else if (durationUnit && !durationValue  && (medicinetype != "Syrup" && medicinetype != "Drops")) {
      showErrorToast("Please select Interval Value!");
      dismissLoader();
      return false;
    }
  //---

  if (medName == "") {
    showErrorToast("Please specify or upload any medicine");
    return false;
  } else {
   
    showLoader();
    const result = await EditMedicine(input);
    
    if (result) {
      // if(showAIModal){
      // await fetchAiDoctorPrompts(input.medicinename);
      // }
      showSuccessToast("Medicine updated Successfully");
      fetchData(medicinetypeFilter, activeTab === 1? "0": "1");
      getFilteredResults()
      editmedications.current.closeModal();
      // detailsmodel.current.closeRight();
      
    }
    setTimeout(() => {
      
    dismissLoader();
    }, 2000);
  }
};

const [timeValues, setTimeValues] = useState([]);

const handleconsumptionfrequencychange = (selectedOption) => {
  setMedicineDosageFrequency(selectedOption)
};
const handleMonthYearChange = (date) => {
                setMedicineExpiryDate(moment(date).format('MM-yyyy'));
              };

              const handleTimeChange = (time) => {
                // Clear frequency inputs when checking a time
                if (time === "morning" && morning !== 1) {
                  setMedicineFreqUnit("");
                  setMedicineFreqValue("");
                } else if (time === "afternoon" && afternoon !== 1) {
                  setMedicineFreqUnit("");
                  setMedicineFreqValue("");
                } else if (time === "night" && setnight !== 1) {
                  setMedicineFreqUnit("");
                  setMedicineFreqValue("");
                }
              
                // Update the specific time state
                switch(time) {
                  case "morning":
                    setMorning(morning === 1 ? 0 : 1);
                    break;
                  case "afternoon":
                    setAfternoon(afternoon === 1 ? 0 : 1);
                    break;
                  case "night":
                    setNight(setnight === 1 ? 0 : 1);
                    break;
                }
              };

              const handleFoodTimingChange = (value) => {
                setFoodTiming(value);
                setBeforefood(value === "before" ? 1 : 0);
                setAfterfood(value === "after" ? 1 : 0);
              };
              // const [night, setNight] = useState(0);
  function handleAdministration(data) {
    console.log('modal Data data: ', data)
    setModalData({
      duration: data.duration,
      frequency: data.frequency,
      frequencytime: data.frequencytime,
      frequencyvalue: data.frequencyvalue,
      morning: data.morning,
      afternoon: data.afternoon,
      evening: data.evening,
      beforefood: data.beforefood,
      afterfood: data.afterfood,
      instructions: data.instructions,

      medicinename: data.medicinename,
      medicinetype: data.medicinetype,
      dosage: data.dosage,
      dosageunit: data.dosageunit,
      chemicalcomposition: data.chemicalcomposition,
      therapeutic: data.therapeutic,
      manufacturer: data.manufacturer,
      drugclass: data.drugclass,
    })
    administration.current.openModal()
  }

  const medicineTypes = [
    "Tablet",
    "Capsule",
    "Syrup",
    "Injection",
    "Ointments / Creams / Gels",
    "Drops",
    "Nebulization",
    "IVFluids",
    "Inhaler",
  ];
  // const medicineTypes = [
  //   "Tablet",
  //   "Capsule",
  //   "Syrup",
  //   "Injection",
  //   "Ointment",
  //   "Cream",
  //   "Gel",
  //   "Drops",
  //   "Nebulization",
  //   "IVFluids",
  //   "Inhaler",
  //   "Respules",
  //   "Suspension",
  //   "Foam",
  //   "Suppository",
  //   "EA",
  //   "Device",
  //   "Sachet",
  //   "Box",
  //   "Spray",
  //   "Lotion",
  //   "Tube",
  //   "Powder",
  //   "Soap",
  //   "Aerosol",
  //   "Shampoo",
  //   "Topical Cleanser",
  //   "Custom",
  // ];

  // const rawTypes = medicineViewData?.length > 9
  //   ? medicineViewData.map((item) => item.medicinetype).filter(Boolean)
  //   : medicineTypes;

  // const uniqueMedicineTypes = Array.from(new Set(rawTypes));


  const adminData = {
    "doctorid": "user123",
    "id": "MED456", 
    "documenttype_cd": "PRESCRIPTION",
    "documentcategory_cd": "MED_ORDER",
    "documentname": "Prescription for Paracetamol",
    "documenturl": "/documents/prescription_456.pdf",
    "prescribedby": "Dr. Smith",
    "hospitalname": "City General Hospital",
    "documentdate": "2025-05-05",
    "medicinename": "Paracetamol",
    "chemical_composition": "Paracetamol 500mg",
    "medicinetype": "Tablet",
    "dosage": "500",
    "dosageunit": "mg",
    "frequency": "2",
    "morning": true,
    "afternoon": false,
    "evening": false,
    "night": true,
    "beforefood": false,
    "afterfood": true,
    "medicineexpirydate": "2026-12-31",
    "iscurrentmedicine": true,
    "longtext": "Take as needed for pain or fever.",
    "documents": [
      { "filename": "prescription_scan_1.jpg" }
    ],
    "routeofadministration": "Oral",
    "timingofinjection": null,
    "quantitytobeapplied": null,
    "areaofapplication": null,
    "diluent": null,
    "additives": null,
    "rateofinfusionvalue": null,
    "rateofinfusionunit": null,
    "duration": "7 Days", // Example duration
    "drugclass": "Analgesic, Antipyretic",
    "therapeutic": "Pain Relief, Fever Reduction",
    "manufacturer": "ABC Pharmaceuticals",
    "instructions": "Take one tablet after meals, twice daily for 7 days.",
    "timingDetails": {
      "morning": true,
      "afternoon": false,
      "night": true,
      "relationToFood": "After Food"
    },
    "frequencyDetails": {
      "type": "Interval",
      "intervalValue": "2",
      "intervalUnit": "Times per day"
    }
  }

  const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};
// ----------------------- multilingual -----------------------------
// waves 
   const recorderRef = useRef(null);
     const [chunks, setChunks] = useState([]);
       const [recording, setRecording] = useState(false);
     
    const [stream, setStream] = useState(null);

    useEffect(() => {
        if (recorderRef.current) return;
    
        if (navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((stream) => {
              setStream(stream);
    
              recorderRef.current = new MediaRecorder(stream);
              // audioContextRef.current = new AudioContext({
              //   sampleRate: WHISPER_SAMPLING_RATE,
              // });
    
              recorderRef.current.onstart = () => {
                setRecording(true);
                setChunks([]);
              };
              recorderRef.current.ondataavailable = (e) => {
                if (e.data.size > 0) {
                  setChunks((prev) => [...prev, e.data]);
                } else {
                  setTimeout(() => {
                    recorderRef.current.requestData();
                  }, 25);
                }
              };
    
              recorderRef.current.onstop = () => {
                setRecording(false);
              };
            })
            .catch((err) => console.error("The following error occurred: ", err));
        } else {
          console.error("getUserMedia not supported on your browser!");
        }
    
        return () => {
          recorderRef.current?.stop();
          recorderRef.current = null;
        };
      }, []);
    

  // ------------------------------------
  //Remove speech and keep Null to toggle between GPU and Speech
  const [SelectedLanguage, setSelectedLanguage] = useState("en-US");
  const [inpLang, setInpLang] = useState("English");
  
  const handleChangeLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; // Get the selected language
    setInpLang(selectedLanguage)
    const languageCode = languageCodeMap[selectedLanguage] || "en-US"; // Default to English (US) if not found

    // Update the language in the transcriber
    setSelectedLanguage(languageCode);
    console.log("Selected Language: ", selectedLanguage);
    console.log("Language Code: ", languageCode);
  };

  const [outLang, setOutputLang] = useState("English")
  const handleChangeOutputLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; 
    // const languageCode = languageCodeMap[selectedLanguage] || "en-US"; 

    // Update the language in the transcriber
    setOutputLang(selectedLanguage);
    console.log("Selected Language OUTPUT: ", selectedLanguage);
    // console.log("Language Code OUTPUT: ", languageCode);
  };
  // const handleChangeLanguage = (e) => {
  //   setSelectedLanguage("English")
  //   const selectedLanguage = e.value;
  //   setSelectedLanguage(selectedLanguage);
  //   console.log("SelectedLanguage: ", SelectedLanguage )

  //   const languageCode = languageCodeMap[selectedLanguage] || "en-US"; // Default to English (US) if not found
  //   setLanguageCode(languageCode);
  //   console.log("languageCode: ", LanguageCode )
  // };
  const language = 'hi-IN';
const { transcriber: activeTranscriber, mode } =
  useHybridTranscriber("speech", (text) => {
    // called when speech recognition finishes
    setPlaceholder(text || "");
    setTyping(false);
},
SelectedLanguage
);
// Add this state to your parent component
const [isRecording, setIsRecording] = useState(false);

// Add this function to handle recording state changes
const handleRecordingStateChange = (recording) => {
  setIsRecording(recording);
};
// ----------------------- Add/Edit REcorder------------------------------
// const activeTranscriber = useGPUTranscriber();

  const [typing, setTyping] = useState(false); // Typing indicator state
  const [HPITextBox, SetHPITextBox] = useState("");

  const [placeholder, setPlaceholder] = useState(
    // "Click anywhere to start typing...."
    "Instructions"
  );

  useEffect(() => {
    // console.log("triggered");
    if (activeTranscriber?.output?.text) {
      setValue("textField", activeTranscriber.output.text);

      handleInstructions(activeTranscriber.output.text);
      // setPlaceholder("Click anywhere to start typing....");
      setPlaceholder("Instructions");
      setTyping(false);
    }
  }, [activeTranscriber?.output, isAddModalOpen]);
  useEffect(() => {
    // console.log("triggered");
    if (activeTranscriber?.output?.text) {
      setValue("textField", activeTranscriber.output.text);

      handleEditInstructions(activeTranscriber.output.text);
      // setPlaceholder("Click anywhere to start typing....");
      setPlaceholder("Instructions");
      setTyping(false);
    }
  }, [activeTranscriber?.output, isEditModalOpen]);

  // newly added
//   useEffect(() => {
//   if (activeTranscriber?.output?.text) {
//     const text = activeTranscriber.output.text;
//     setPlaceholder("Instructions");
//     setTyping(false);

//     if (instructions) {
//       handleInstructions(text);
//       setValue("textField", text, {
//         shouldDirty: true,
//         shouldTouch: true,
//         shouldValidate: true,
//       });
//     } else if (editCurrentMedicine) {
//       handleInstructions(text);
//       setValue("textField", text, {
//         shouldDirty: true,
//         shouldTouch: true,
//         shouldValidate: true,
//       });
//     }
//   }
// }, [activeTranscriber?.output?.text]);

  const { register, handleSubmit, watch, setValue } = useForm();
  const textFieldValue = watch("textField", "");
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [initialText, setInitialText] = useState("");

  const onSubmit = (data) => {
      setIsButtonDisabled(true); // Disable button on submit
      // UpdateHpiTextBox(data);
      SetHPITextBox(data);
      // fetchDoctorNotesEmptyIndication();
    };
  
     // submit on tab switch and submit button is enalbed
      useEffect(()=>{
          if(!isButtonDisabled){
          handleSubmit(onSubmit)();
          }
      },[])
  
    useEffect(() => {
      if (textFieldValue !== initialText) {
        setIsButtonDisabled(false); // Enable button if text field value changes
      } else {
        setIsButtonDisabled(true); // Disable button if text field value is unchanged
      }
    }, [textFieldValue, initialText]);

const correctOrders = async (formType) => {
    // const currentText = watch("textField");
    let currentText = "";
  if (formType === "add") {
    currentText = instructions || "";
  } else if(formType === "edit") {
    currentText = editInstructions || "";
  }

  const getDoctorSpecialti = localStorage.getItem('doctorSpecialities')
  const getDoctorExp = localStorage.getItem('doctorExperience')
    
    if (!currentText) {
      showErrorToast("No text available to correct");
      return;
    }

    const inputToSave = {
      input: {
        text: currentText,
        type: `medicine_instructions#${getDoctorSpecialti}#${getDoctorExp}#ConsultationNote#${inpLang}#${outLang}`,
      },
    };

    showLoader();
    try {
      // const result = await CorrectInstructionsUsingAI(inputToSave.input);
      const result = await CorrectMedicalTermsUsingAI(inputToSave);
      if (result) {
        showSuccessToast("Updated Text");
        const updatedText = result?.text;

        if (formType === "add") {
        handleInstructions(updatedText);
        setValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      } else if (formType === "edit") {
        handleEditInstructions(updatedText);
        setValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      }      
        setIsButtonDisabled(false);
      }
    } catch (error) {
      console.error("Error in Correct AI call:", error);
      showErrorToast("Error Happened While Correcting.");
    } finally {
      dismissLoader();
    }
};

// Format medicine display name
const formatMedicineName = (medicine) => {
  if (!medicine) return "";
  
  const type = medicine.medicinetype?.toLowerCase() || "";
  const name = medicine.medicinename || "";
  const dosage = medicine.dosage || "";
  const dosageUnit = medicine.dosageunit || "";
  
  // Capitalize first letter of medicine name
  let formattedName = name.charAt(0).toUpperCase() + name.slice(1);
  
  // Add type prefix - USE formattedName, not name!
  if (type.includes("tab") || type === "tablet") {
    formattedName = `Tab. ${formattedName}`;
  } else if (type.includes("cap") || type === "capsule") {
    formattedName = `Cap. ${formattedName}`;
  } else if (type.includes("syr") || type === "syrup") {
    formattedName = `Syr. ${formattedName}`;
  } else if (type.includes("inj") || type === "injection") {
    formattedName = `Inj. ${formattedName}`;
  } else if (type.includes("cream")) {
    formattedName = `Crm. ${formattedName}`;
  } else if (type === "ointment" || type.includes("oint")) {
    formattedName = `Oint. ${formattedName}`;
  } else if (type.includes("drop") || type === "drops") {
    formattedName = `Drops ${formattedName}`;
  } else if (type.includes("powder")) {
    formattedName = `Powder ${formattedName}`;
  } else if (type.includes("liquid") || type.includes("solution")) {
    formattedName = `Liq. ${formattedName}`;
  } else if (type.includes("gel")) {
    formattedName = `Gel ${formattedName}`;
  }
  
  // Add dosage if available
  if (dosage) {
    formattedName = formattedName.replace(/-$/, '');
    formattedName += `-${dosage}${dosageUnit}`;
  }
  
  return formattedName;
};

  return (
    <>
    {screenType == 'web' ? (
      <Box w="100%">
      <Flex>
        <Box w="6rem">
          <MiniSideBar />
        </Box>
        {isLoading && <Loader />}
        <Box w="100%">
          <SecondaryNav customHeader="Medicine Catalog" />
          <Box gap='10px' w='calc(100vw - 6rem)' p='1rem' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
              {/* <PrimaryInput
                variant="fullRound"
                title="Search by name"
                inputPlace="Search"
                id="yourName"
                onKeyDown={handleKeyDown}
                onChange={handleChangeName}
                inputValue={name}
              /> */}
              {/* <Box w='800px'>
              <DatePicker
                  disableFutureDates={true}
                  // defaultDate={procedureDate}
                  onDateChange={(selectedDateValue) =>
                    handleLastUsedDate(selectedDateValue)
                  }
                  placeholderProp="Last Used Date"
                  datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px" }}
                  value={lastUsedDate} 
                  clearValue={true}
                />
              </Box> */}
              <PrimaryInput
                variant="fullRound"
                title="Search by Medicine name"
                inputPlace="Medicine name"
                name="medicine"
                onKeyDown={handleKeyDown}
                onChange={handleInputChange}
                inputValue={search.medicine}
              />
              <PrimaryInput
                variant="fullRound"
                title="Search by Composition"
                inputPlace="Composition"
                name="composition"
                onKeyDown={handleKeyDown}
                onChange={handleInputChange}
                inputValue={search.composition}
              />
              {/* <PrimaryInput
                variant="fullRound"
                title="Search by strength"
                inputPlace="Strength"
                name="dosage"
                onKeyDown={handleKeyDown}
                onChange={handleInputChange}
                inputValue={search.dosage}
              /> */}
              <DropdownInput
                variant="fullSide"
                dropDownPlace="Type"
                inputStyleCss={{w: '65%'}}
                options={medicineTypes}
                // options={uniqueMedicineTypes}
                onClick={(selectedOption) =>
                  handlemedicinetypechange(selectedOption, "filter")
                }
                value={filterMedicinetype}
              />
              <PrimaryInput
                variant="fullRound"
                title="Search by Drug class"
                inputPlace="Drug class"
                name="drugClass"
                onKeyDown={handleKeyDown}
                onChange={handleInputChange}
                inputValue={search.drugClass}
              />
              <PrimaryInput
                variant="fullRound"
                title="Search by Therapeutic"
                inputPlace="Therapeutic"
                name="therapeutic"
                onKeyDown={handleKeyDown}
                onChange={handleInputChange}
                inputValue={search.therapeutic}
              />
              {/* <PrimaryInput
                variant="fullRound"
                title="Search by Manufacturer"
                inputPlace="Manufacturer"
                name="manufacturer"
                onKeyDown={handleKeyDown}
                onChange={handleInputChange}
                inputValue={search.manufacturer}
              /> */}
              {/* <Box w='800px'>
              <DatePicker
                  // defaultDate={procedureDate}
                  onDateChange={(selectedDateValue) =>
                    handleFromDate(selectedDateValue)
                  }
                  placeholderProp="From Date"
                  datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px" }}
                  value={fromDate} 
                  clearValue={true}

                  CUSTOM_DISABLE={true}
                  disableFutureDates={true}
                  maxDate={toDateMinMax}
                />
              </Box>
                <Box w='800px'>
              <DatePicker
                  onDateChange={(selectedDateValue) =>
                    handleToDate(selectedDateValue)
                  }
                  placeholderProp="To Date"
                  datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px " }}
                  value={toDate} 
                  clearValue={true}
                  
                CUSTOM_DISABLE={true}
                maxDate={new Date().toISOString()} 
                minDate={fromDateMinMax}
                />
                </Box> */}

              <Box gap='10px' pl='1rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                <PrimaryButton buttonText="Filter" id="filterButton" onClick={handleApplyFilters}  btnStyle={{m:'0' }} />
                <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27", m:'0' }} onClick={resetFields} />
                <PrimaryButton
                  buttonText="Add"
                  onClick={addData}
                  btnStyle={{ m:0 }}
                  isDisabled={ actionAccess && (!actionAccess.create) ? true : false} 
                />
              </Box>

              <Box gap='10px' pl='1rem' w='100%' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                <PrimaryButton
                buttonText="Drug Database Management"
                // onClick={addData}
                onClick={() => navigate("/drugdatabasemanagement")}
                btnStyle={{ m:0 }}
                variant="mdBtnFull"
                btnIcon="/assets/svgs/new-tab.svg"
                iconSrc={true}
                iconSrcStyle={{ w: "14px" }}
                isDisabled={ actionAccess && (!actionAccess.create) ? true : false} 
                />
              </Box>
              {noData && <p>No data available</p>}
              </Box>
          {medicineViewData && medicineViewData.length > 0 ? (
            <>
                        <SimpleGrid
                          h="calc(100vh - 210px)"
                          overflow="hidden auto"
                          border="1px solid #E6E7E9"
                          w="100%"
                          gap="1rem"
                          p="1rem"
                          columns={{ base: 1, md: 2, lg: 3 }}
                        >
                          {medicineViewData &&
                            medicineViewData.map((medicine, index) => (
                              <Card
                                borderRadius="12px"
                                key={index}
                                w="100%"
                                border="1px solid #E6E7E9"
                                boxShadow="0px 8px 20px 0px #E6E7E966"
                                h="min-content"
                              >
                                <CardBody p={{ base: "0.875rem", lg: "0.875rem", xl: "1.25rem" }}>
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    mb="0.75rem"
                                  >
                                    <Box
                                      cursor="pointer"
                                      display="flex"
                                      alignItems="center"
                                      flex="1"
                                      minW="0"
                                    >
                                      <Box display="flex" flex="1" minW="0">
                                        <Text
                                          fontSize="15px"
                                          fontWeight="600"
                                          isTruncated
                                          textOverflow="ellipsis"
                                          whiteSpace="nowrap"
                                          overflow="hidden"
                                          // title={`${medicine.medicinename} (${medicine.medicinetype}${" "} ${" "}`}
                                          title={`${formatMedicineName(medicine)}`}
                                          maxW="100%"
                                        >
                                          {formatMedicineName(medicine)} 
                                          {/* {medicine.medicinename} */}
                                          {/* <Box as="span" bg='#E6E7E966' ml='0.25rem' border='1px solid #E6E7E9' borderRadius='8px' fontSize='10px' p='0.25rem'>
                                            {medicine.medicinetype ? medicine.medicinetype : "-"}
                                          </Box> */}
                                        </Text>
                                      </Box>
                                    </Box>

                                    <Box display="flex" width="auto" minW="1rem" gap="10px">
                                  <Box
                                    as="button"
                                    onClick={()=> handleAdministration(medicine)}
                                    border="1px solid #E6E7E9"
                                    borderRadius="full"
                                    w="36px"
                                    h="auto"
                                    p="10px"
                                  >
                                    <Image
                                      w="16px"
                                      src="/assets/imgs/show-pass.png"
                                    />
                                  </Box>

                                  <Box
                                    as="button"
                                    onClick={() => handlefavouritemedication(medicine)}
                                    border="1px solid #E6E7E9"
                                    borderRadius="full"
                                    w="36px"
                                    h="36px"
                                    p="0"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    // bg={(medicine.fav == 1) ? "#FFE5E5" : "white"}
                                    _hover={{ 
                                      // bg: (medicine.fav == 1) ? "#FFD1D1" : "#F8F9FA",
                                      // borderColor: (medicine.fav == 1) ? "#FF6B6B" : "#E6E7E9"
                                      cursor: "pointer",
                                    }}
                                    transition="all 0.2s ease"
                                  >
                                    <Icon
                                      as={(medicine.fav == 1) ? FaHeart : FaRegHeart}
                                      w="13px"
                                      h="13px"
                                      // color={(medicine.fav == 1) ? "#FF4444" : "#666666"}
                                      color={(medicine.fav == 1) ? "#FF6B6B" : "#666666"}
                                    />
                                  </Box>

                                  <Box
                                    as="button"
                                    onClick={() => handleeditmedication(medicine)}
                                    border="1px solid #E6E7E9"
                                    borderRadius="full"
                                    w="36px"
                                    h="auto"
                                    p="10px"
                                  >
                                    <Image
                                      w="13px"
                                      src="/assets/imgs/edit-gray.png"
                                    />
                                  </Box>

                                  <Box
                                    as="button"
                                    onClick={() => {
                                      openDeleteModal(medicine.id, medicine);
                                    }}
                                    border="1px solid #E6E7E9"
                                    borderRadius="full"
                                    w="36px"
                                    h="auto"
                                    p="10px"
                                  >
                                    <Image
                                      w="13px"
                                      src="/assets/imgs/delete.png"
                                    />
                                  </Box>
                                </Box>

                                    {/* <Box display="flex" width="auto" minW="1rem" gap="10px">
                                      <Menu isLazy>
                                        <MenuButton as="button" zIndex={99}>
                                          <Image
                                            w="1rem"
                                            src="/assets/svgs/more-options.svg"
                                            transform="rotate(90deg)"
                                          />
                                        </MenuButton>
                                        <MenuList zIndex={9} pos="relative" right="0px" minW="125px">
                                          <MenuItem
                                            onClick={()=> handleAdministration(medicine)}
                                            isDisabled={
                                              actionAccess && !actionAccess.update ? true : false
                                            }
                                          >
                                            More details
                                          </MenuItem>
                                          <MenuItem
                                            onClick={() => handleeditmedication(medicine)}
                                            isDisabled={
                                              actionAccess && !actionAccess.update ? true : false
                                            }
                                          >
                                            Edit
                                          </MenuItem>
                                          <MenuItem
                                            onClick={() => {
                                              openDeleteModal(medicine.id, medicine.medicinename);
                                            }}
                                          >
                                            Delete
                                          </MenuItem>
                                        </MenuList>
                                      </Menu>
                                    </Box> */}
                                  </Box>
                                  <Flex w="100%" mb="0.75rem" justifyContent="space-between">
                                    <Box display="flex" flexDir="column" w={"100%"}>
                                      <Text fontSize="10px" color="gray.500">
                                        Composition
                                      </Text>
                                      <Text fontSize="12px" fontWeight="600">
                                        {/* {medicine?.chemicalcomposition ? medicine?.chemicalcomposition : "-"} - ({medicine.dosage}{" "} {medicine.dosageunit}){" "} */}

                                        {medicine?.chemicalcomposition ? medicine?.chemicalcomposition : "-"}
                                        {/* {medicine?.dosage && ` - (${medicine.dosage} ${medicine.dosageunit})`} */}
                                      </Text>
                                    </Box>
                                  </Flex>

                                  <Flex w="100%" gap='10px'>
                                    <Box display="flex" flexDir="column" w={"100%"}>
                                      <Text fontSize="10px" color="gray.500">
                                       Drug Class
                                      </Text>
                                      <Text fontSize="12px" fontWeight="600">
                                        {medicine.drugclass ? medicine.drugclass : "-"}
                                      </Text>
                                    </Box>
                                    <Box display="flex" flexDir="column"  w="100%">
                                      <Text fontSize="10px" color="gray.500">
                                      Therapeutic
                                      </Text>
                                      <Box as="button" w="100%">
                                        <Text
                                          fontSize="12px"
                                          fontWeight="600"
                                          isTruncated
                                          textAlign="left"
                                        >
                                          {medicine?.therapeutic ? medicine?.therapeutic : "-"}
                                        </Text>
                                      </Box>
                                    </Box>
                                    <Box w="100%" display="flex" flexDir="column">
                                      <Text fontSize="10px" color="gray.500">
                                      Manufacturer
                                      </Text>
                                      <Text fontSize="12px" fontWeight="600">
                                      {medicine?.manufacturer ? medicine?.manufacturer : "-"}
                                      </Text>
                                      
                                    </Box>
                                  </Flex>
                                </CardBody>
                              </Card>
                            ))}
                        </SimpleGrid>;

                      <Box
                        w="100%"
                        pos="sticky"
                        bottom="0"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        p="0.5rem 1.5rem"
                        bg='white'
                        boxShadow="rgba(0, 0, 0, 0.35) 0px 5px 15px;"
                      >
                        <Box
                          visibility={
                            totalItemCount < countTo && !totalExceedsPageCount ? "hidden" : "visible"
                          }
                        >
                          <Text>
                            Showing <b>{countFrom}</b> to <b>{countTo}</b> of {totalItemCount} results
                          </Text>
                        </Box>
                        <Box
                          gap="2.5rem"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Box
                            as="button"
                            onClick={handlePrevClick}
                            disabled={currentPage === 1}
                            visibility={currentPage === 1 ? "hidden" : "visible"}
                            p="0.5rem 0.75rem"
                            border="0.0625rem solid #E6E7E9"
                            borderRadius="0.75rem"
                            fontSize="1rem"
                            fontWeight="500"
                          >
                            Previous
                          </Box>
                          <Box>
                            <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                              Page {currentPage} of {totalPages}
                            </Text>
                          </Box>
                          {totalItemCount >= countTo && !totalExceedsPageCount && (
                            <Box
                              as="button"
                              p="0.5rem 0.75rem"
                              mr="2.5rem"
                              border="0.0625rem solid #E6E7E9"
                              borderRadius="0.75rem"
                              onClick={handleNextClick}
                              disabled={currentPage === totalPages}
                              visibility={currentPage === totalPages ? "hidden" : "visible"}
                              fontSize="1rem"
                              fontWeight="500"
                            >
                              Next
                            </Box>
                          )}
                        </Box>
                      </Box>

            </>
                    ) : (
                      <Box width='100%'>
                        {/* <PrimaryButton
                          buttonText="Add"
                          onClick={addData}
                          variant="mdBtn"
                          btnStyle={{ w: "8%", my: "1rem" }}
                          w='100%'
                          ml='87%'
                          isDisabled={ actionAccess && (!actionAccess.create) ? true : false} 
                        /> */}
                      <SimpleTable
                        headers={TableHeader}
                        // isDataPresent={false}
                      />
                      </Box>
                    )}
                        </Box>
      </Flex>
      </Box>
    ) : (
      <>
          <MobileNavbar />
          <MobileSecondaryNav
            header="Medicine View"
            handlebackarrow={false}
          />

          <Box
            w="100%"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p="1rem"
            gap='0.75rem'
          >
            <PrimaryInput
              variant="fullRound"
              title="Search by Composition"
              inputPlace="Composition"
              name="composition"
              onKeyDown={handleKeyDown}
              onChange={handleInputChange}
              inputValue={search.composition}
            />
            <Box onClick={onToggle}>
              <Image
                w='50px'
                cursor='pointer'
                src={isOpen ? "assets/svgs/outline-f.svg" : "assets/svgs/filled-f.svg" }
              />
            </Box>
            <PrimaryButton
              buttonText="Add"
              onClick={addData}
              variant="mdBtn"
              isDisabled={actionAccess && !actionAccess.create ? true : false}
            />
          </Box>

          <Collapse in={isOpen} animateOpacity zIndex='9999' pos='relative' style={{overflow:'visible'}}>
            <Box w="100%" display="flex" p='1rem' pt='0' flexDir='column' zIndex='9999' pos='relative' gap="10px">
            <PrimaryInput
                variant="fullRound"
                title="Search by strength"
                inputPlace="Strength"
                name="dosage"
                onKeyDown={handleKeyDown}
                onChange={handleInputChange}
                inputValue={search.dosage}
              />
              <DropdownInput
                variant="fullSide"
                dropDownPlace="Type"
                options={medicineTypes}
                // options={uniqueMedicineTypes}
                onClick={(selectedOption) =>
                  handlemedicinetypechange(selectedOption, "filter")
                }
                value={filterMedicinetype}
              />
              <PrimaryInput
                variant="fullRound"
                title="Search by Drug class"
                inputPlace="Drug class"
                name="drugClass"
                onKeyDown={handleKeyDown}
                onChange={handleInputChange}
                inputValue={search.drugClass}
              />
            </Box>

            <Box w="100%" p='1rem' pt='0' display="flex" gap="10px">
              <PrimaryButton
                buttonText="Filter"
                btnStyle={{w:"100%"}}
                id="filterButton"
                variant="mdBtn"
                onClick={handleApplyFilters}
              />
              <PrimaryButton
                buttonText="Reset"
                id="resetButton"
                variant="grayBtn"
                btnStyle={{ color: "#AA2F27", w:"100%" }}
                onClick={resetFields}
              />
            </Box>
          </Collapse>


          <Box
          h="calc(100vh - 200px)"
          overflow='hidden auto'
          border="1px solid #E6E7E9"
          p='1rem'
          display='flex'
          gap='0.75rem'
          flexDir='column'
          >
          {medicineViewData &&
              medicineViewData.map((medicine, index) => (
          <Card
            borderRadius="12px"
            key={index}
            w="100%"
            border="1px solid #E6E7E9"
            boxShadow="0px 8px 20px 0px #E6E7E966"
          >
             <CardBody p={{ base: "0.875rem", lg: "0.875rem", xl: "1.25rem" }}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  mb="0.75rem"
                >
                  <Box
                    cursor="pointer"
                    display="flex"
                    alignItems="center"
                    flex="1"
                    minW="0"
                  >
                    <Box display="flex" flex="1" minW="0">
                      <Text
                        fontSize="15px"
                        fontWeight="600"
                        isTruncated
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                        overflow="hidden"
                        title={`${medicine.medicinename} (${medicine.medicinetype}${" "} ${" "}`}
                        maxW="100%"
                      >
                        <Box as="span" bg='#E6E7E966' mr='0.25rem' border='1px solid #E6E7E9' borderRadius='8px' fontSize='10px' p='0.25rem'>
                          {medicine.medicinetype ? medicine.medicinetype : "-"}
                        </Box>
                        {medicine.medicinename} 
                      </Text>
                    </Box>
                  </Box>

                  <Box display="flex" width="auto" minW="1rem" gap="10px">
                    <Menu isLazy>
                      <MenuButton as="button" zIndex={99}>
                        <Image
                          w="1rem"
                          src="/assets/svgs/more-options.svg"
                          transform="rotate(90deg)"
                        />
                      </MenuButton>
                      <MenuList zIndex={9} pos="relative" right="0px" minW="125px">
                        <MenuItem
                          onClick={()=> handleAdministration(medicine)}
                          isDisabled={
                            actionAccess && !actionAccess.update ? true : false
                          }
                        >
                          More details
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleeditmedication(medicine)}
                          isDisabled={
                            actionAccess && !actionAccess.update ? true : false
                          }
                        >
                          Edit
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            openDeleteModal(medicine.id, medicine.medicinename);
                          }}
                        >
                          Delete
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </Box>
                </Box>
                <Flex w="100%" mb="0.75rem" justifyContent="space-between">
                  <Box display="flex" flexDir="column" w={"100%"}>
                    <Text fontSize="10px" color="gray.500">
                      Composition
                    </Text>
                    <Text fontSize="12px" fontWeight="600">
                      {medicine?.chemicalcomposition ? medicine?.chemicalcomposition : "-"} - ({medicine.dosage}{" "} {medicine.dosageunit}){" "}
                    </Text>
                  </Box>
                </Flex>

                <Flex w="100%" gap='10px'>
                  <Box display="flex" flexDir="column" w={"100%"}>
                    <Text fontSize="10px" color="gray.500">
                      Drug Class
                    </Text>
                    <Text fontSize="12px" fontWeight="600">
                      {medicine.drugclass ? medicine.drugclass : "-"}
                    </Text>
                  </Box>
                  <Box display="flex" flexDir="column"  w="100%">
                    <Text fontSize="10px" color="gray.500">
                    Therapeutic
                    </Text>
                    <Box as="button" w="100%">
                      <Text
                        fontSize="12px"
                        fontWeight="600"
                        isTruncated
                        textAlign="left"
                      >
                        {medicine?.therapeutic ? medicine?.therapeutic : "-"}
                      </Text>
                    </Box>
                  </Box>
                  <Box w="100%" display="flex" flexDir="column">
                    <Text fontSize="10px" color="gray.500">
                    Manufacturer
                    </Text>
                    <Text fontSize="12px" fontWeight="600">
                    {medicine?.manufacturer ? medicine?.manufacturer : "-"}
                    </Text>
                    
                  </Box>
                </Flex>
              </CardBody>

          </Card>
          ))}
          </Box>
        </>
    )}


<DynamicModal
      ref={addmedications}
      modalHeader="Add Medication"
      modalWidth={{base:'100%', md: 'calc(100vw - 10%)'}}
      modalBody={
        <>
          <Box display="flex" flexDir="column" gap="20px">
            <Stack>
              <Flex>
                <InputGroup>
                  <Input
                    pr="4.5rem" // Padding right to make room for the icon
                    type="text"
                    placeholder="Medicine name*"
                    // value={medicinename}
                    value={medicinename.charAt(0).toUpperCase() + medicinename.slice(1)}
                    sx={{
                      height: "48px",
                      borderRadius: "10px 0 0 10px",
                      _hover: {
                        border: "2px solid",
                        borderColor: COLORS.INPUT_FOCUS_DARK,
                        outline: "none",
                        bg: "none",
                        _focus: {
                          borderRadius: "10px",
                          borderColor: COLORS.INPUT_FOCUS_DARK,
                          outline: "none",
                        },
                        _focusVisible: { borderColor: "none" },
                      },
                    }}
                    onChange={handlemedicinename}
                    maxLength={80}
                  />
                  <InputRightElement width="4.5rem">
                    <Box
                      as="button"
                      h="1.75rem"
                      bg="none"
                      pt="8px"
                      onClick={() => document.getElementById("file-upload").click()}
                      sx={{ _hover: { bg: "none" } }}
                    >
                      <Image src="/assets/svgs/image-search-blue.svg" />
                    </Box>
                    <input
                      type="file"
                      id="file-upload"
                      style={{ display: "none" }}
                      //onChange={(e) => setFile(e.target.files[0])}
                      onChange={handleimageselection}
                    />
                  </InputRightElement>
                </InputGroup>
                <PrimaryInput
                  variant={"bothSide"}
                  onChange={handleManufacturer}
                  inputPlace="Manufacturer"
                  defaultValue={manufacturer}
                  inputValue={manufacturer}
                />
                  <PrimaryInput
                    variant="bothSide"
                    inputValue={Composition}
                    onChange={(event) => setComposition(event.target.value)}
                    inputPlace="Medicine Composition*"
                  />
                  <Box
                      as="button"
                      type="button"
                      border="1px solid #E6E7E9"
                      // borderRadius="full"
                      width={{ base: "100%", md: "10%" }}
                      // w="40px"
                      // h="40px"
                      p="8px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                      // opacity={medicineTextFieldValue ? 1 : 0.5}
                      // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                      onClick={() => {
                      if (isChatbotAllowed()) {
                        fetchComposition(medicinename);
                      } else {
                        showErrorToast("Please upgrade your subscription to use this feature");
                      }
                    }}
                    isDisabled={!isChatbotAllowed()}
                    title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                      bg="white"
                      // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                    >
                      <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                    </Box>
                  {/* <PrimaryButton
                    buttonText="Fetch"
                    verticalAlign="bottom"
                    variant="grayBtn"
                    btnStyle={{
                      w: "15%",
                      color: COLORS.PRIMARY_COLOR,
                      verticalAlign: "bottom",
                      ml: "4px",
                      mb: "0px",
                      h: "48px",
                      m: "0",
                      borderRadius: "0 10px 10px 0",
                      opacity: isChatbotAllowed() ? 1 : 0.6,
                      cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                    }}
                    onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchComposition(medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                    // onClick={() => fetchComposition(medicinename)}
                    // isDisabled={false}
                  /> */}
              </Flex>
              {/* <Divider /> */}
              {/* <Text fontSize="10px" color="gray.500">Medicine Type*</Text> */}
              <RadioGroup
                // mt="1rem"
                // defaultValue={medicineTypeRadio || "Tablet"}
                value={medicinetype}
                // onChange={handlemedicinetypechange}
                 onChange={(value) => {
                console.log("Radio selected:", value);
                handlemedicinetypechange(value, "radio");
              }}
              >
                <Stack direction="row" alignItems='center' spacing={4} wrap="wrap">
                  <Radio colorScheme="green" value="Tablet">Tablet</Radio>
                  <Radio colorScheme="green" value="Capsule">Capsule</Radio>
                  <Radio colorScheme="green" value="Syrup">Syrup</Radio>
                  <Radio colorScheme="green" value="Drops">Drops</Radio>
                  <Radio colorScheme="green" value="Injection">Injection</Radio>
                  <Radio colorScheme="green" value="Nebulization">Nebulization</Radio>
                  <Radio colorScheme="green" value="IVFluids">IV Fluids</Radio>
                  <Radio colorScheme="green" value="Inhaler">Inhaler</Radio>
                  <Radio colorScheme="green" value="Sachet">Sachet</Radio>
                  <Radio colorScheme="green" value="Ointment">Ointment</Radio>
                  <Radio colorScheme="green" value="Cream">Cream</Radio>
                  <Radio colorScheme="green" value="Gel">Gel</Radio>

                  {/* <Radio colorScheme="green" value="Respules">Respules</Radio>
                  <Radio colorScheme="green" value="Suspension">Suspension</Radio>
                  <Radio colorScheme="green" value="Foam">Foam</Radio>
                  <Radio colorScheme="green" value="Suppository">Suppository</Radio>
                  <Radio colorScheme="green" value="EA">EA</Radio>
                  <Radio colorScheme="green" value="Device">Device</Radio>
                  <Radio colorScheme="green" value="Box">Box</Radio>
                  <Radio colorScheme="green" value="Spray">Spray</Radio>
                  <Radio colorScheme="green" value="Lotion">Lotion</Radio>
                  <Radio colorScheme="green" value="Tube">Tube</Radio>
                  <Radio colorScheme="green" value="Gargle">Gargle</Radio>
                  <Radio colorScheme="green" value="Powder">Powder</Radio>
                  <Radio colorScheme="green" value="Soap">Soap</Radio>
                  <Radio colorScheme="green" value="Aerosol">Aerosol</Radio>
                  <Radio colorScheme="green" value="Shampoo">Shampoo</Radio>
                  <Radio colorScheme="green" value="Topical Cleanser">Topical Cleanser</Radio>
                  <Radio colorScheme="green" value="Custom">Custom</Radio> */}
                  <Text>-Or-</Text>
                  <Box mx='1rem'>

                    <DropdownInput
                            variant="bothSide"
                            dropDownPlace="More Types"
                            options={additionalMedicineTypes}
                            onClick={(value) => {
                              console.log("Dropdown selected:", value);
                              handleDropdownMedTypeChange(value);
                            }}
                            value={dropdownMedType}
                            defaultOption={dropdownMedType || "Select more types"}
                            // Add a clear prop if your DropdownInput component supports it
                            clearValue={() => setDropdownMedType("")}
                          />
                {/* <DropdownInput
  variant="bothSide"
  dropDownPlace="More Medicine Types"
  options={additionalMedicineTypes}
  onClick={(value) => handleDropdownMedTypeChange(value)}
  value={dropdownMedType}
  defaultOption={dropdownMedType || "Select more types"}
/> */}

                  </Box>
                </Stack>
              </RadioGroup>
              {/* <Divider /> */}
              <Box>
                <Flex>
                <PrimaryInput
                  variant={"bothSide"}
                  onChange={handleDrugClass}
                  inputPlace="Drug Class*"
                  defaultValue={drugClass}
                  inputValue={drugClass}
                />
                <PrimaryInput
                  variant={"bothSide"}
                  onChange={handleTherapeuticCategory}
                  inputPlace="Therapeutic category"
                  defaultValue={therapeutic}
                  inputValue={therapeutic}
                />
                {medicinetype == "Tablet" || medicinetype == "Capsule" || medicinetype == "Suppository" || medicinetype == "Powder" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "mcg", value: "mcg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength*"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Inhaler" || medicinetype === "Spray" || medicinetype === "Aerosol" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "puffs", value: "puffs" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
    ]}
    placeholderProp="Volume"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Syrup" ||
    medicinetype === "IVFluids" ||
    medicinetype === "Nebulization" ||
    medicinetype === "Drops" ||
    medicinetype === "Injection" ||
    medicinetype === "Suspension" ||
    medicinetype === "Respules" ||
    medicinetype === "Gargle" ||
    medicinetype === "Shampoo" ||
    medicinetype === "Topical Cleanser" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "ml", value: "ml" }]}
    placeholderProp="Volume"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Ointment" ||
    medicinetype === "Cream" ||
    medicinetype === "Gel" ||
    medicinetype === "Foam" ||
    medicinetype === "Lotion" ||
    medicinetype === "Tube" ||
    medicinetype === "Soap" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "grms", value: "grms" }, { label: "ml", value: "ml" }]}
    placeholderProp="Weight/Volume"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "EA" || medicinetype === "Device" || medicinetype === "Box" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "each", value: "each" }]}
    placeholderProp="Count"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Sachet" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : (
  // Default case for CUSTOM and any unexpected types
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
      { label: "puffs", value: "puffs" },
      { label: "each", value: "each" },
    ]}
    placeholderProp={medicinetype === "Custom" ? "Custom Unit" : "Strength"}
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
)}

{medicinetype == "IVFluids" && (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "ml/hr", value: "ml/hr" },
      { label: "ml/min", value: "ml/min" },
    ]}
    handleInputChange={(e) =>
      setRateOfInfusionValue(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    placeholderProp={"Rate of Infusion"}
    onSelect={handleRateOfInfusionUnit}
    maxLength="6"
  />
)}

                {/* existing code */}
                {/* {medicinetype == "Tablet" || medicinetype == "Capsule" ? (
                  <MiniDropdownInput
                    variant="bothSide"
                    options={[
                      { label: "mg", value: "mg" },
                      { label: "mcg", value: "mcg" },
                      { label: "g", value: "g" },
                    ]}
                    placeholderProp={
                      medicinetype == "Syrup" ||
                      medicinetype == "Injection" ||
                      medicinetype == "Nebulization" ||
                      medicinetype == "IVFluids" ||
                      medicinetype == "Drops"
                        ? "Volume"
                        : "Strength"
                    }
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(
                        validationOfNumberWithOnly1Decimal(e.target.value),
                      )
                    }
                    inputVal={dosage}
                    defaultOptionProp={dosageunit}
                    maxLength="6"
                  />
                ) : medicinetype === "Inhaler" ? (
                  <MiniDropdownInput
                    variant="bothSide"
                    options={[
                      { label: "puffs", value: "puffs" },
                      { label: "ml", value: "ml" },
                      { label: "grms", value: "grms" },
                    ]}
                    placeholderProp={
                      medicinetype == "Inhaler" ? "Volume" : "Strength"
                    }
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(
                        validationOfNumberWithOnly1Decimal(e.target.value),
                      )
                    }
                    inputVal={dosage}
                    defaultOptionProp={dosageunit}
                    maxLength="6"
                  />
                ) : medicinetype === "Syrup" ||
                  medicinetype === "IVFluids" ||
                  medicinetype === "Nebulization" ||
                  medicinetype === "Drops" ||
                  medicinetype === "Injection" ? (
                  <MiniDropdownInput
                    variant="bothSide"
                    options={[{ label: "ml", value: "ml" }]}
                    placeholderProp={
                      medicinetype == "Syrup" ||
                      medicinetype == "Injection" ||
                      medicinetype == "Nebulization" ||
                      medicinetype == "IVFluids" ||
                      medicinetype == "Drops"
                        ? "Volume"
                        : "Strength"
                    }
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(
                        validationOfNumberWithOnly1Decimal(e.target.value),
                      )
                    }
                    inputVal={dosage}
                    defaultOptionProp={dosageunit}
                    maxLength="6"
                  />
                ) : (
                  <MiniDropdownInput
                    variant="bothSide"
                    options={[
                      { label: "mg", value: "mg" },
                      { label: "ml", value: "ml" },
                      { label: "grms", value: "grms" },
                    ]}
                    placeholderProp={
                      medicinetype == "Syrup" ||
                      medicinetype == "Injection" ||
                      medicinetype == "Nebulization" ||
                      medicinetype == "IVFluids" ||
                      medicinetype == "Drops"
                        ? "Volume"
                        : "Strength"
                    }
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(
                        validationOfNumberWithOnly1Decimal(e.target.value),
                      )
                    }
                    inputVal={dosage}
                    defaultOptionProp={dosageunit}
                    maxLength="6"
                  />
                )}

                {medicinetype == "IVFluids" && (
                  <MiniDropdownInput
                    variant="bothSide"
                    options={[
                      { label: "ml/hr", value: "ml/hr" },
                      { label: "ml/min", value: "ml/min" },
                    ]}
                    handleInputChange={(e) =>
                      setRateOfInfusionValue(
                        validationOfNumberWithOnly1Decimal(e.target.value),
                      )
                    }
                    placeholderProp={"Rate of Infusion"}
                    onSelect={handleRateOfInfusionUnit}
                    maxLength="6"
                  />
                )} */}

                <DropdownInput
                  variant="bothSide"
                  dropDownPlace={
                    medicinetype == "Ointment" || medicinetype === "Cream" || medicinetype === "Gel"
                      ? "Application Frequency"
                      : medicinetype == "Nebulization" ||
                          medicinetype == "Inhaler" ||
                          medicinetype == "IVFluids"
                        ? "Frequency"
                        : "Consumption Quantity"
                  }
                  // options={["0.5", "1", "2", "3", "4"]}
                  options={(medicinetype === "Ointment" || medicinetype === "Cream" || medicinetype === "Gel") ? ["1", "2", "3", "4"] : ["0.5", "1", "2", "3", "4"]}
                  onClick={handleconsumptionfrequencychange}
                  value={frequency || "1"}
                  defaultOption={frequency || "1"}
                />
              </Flex>
                {/* <Divider my="10px" /> */}
              <Flex flexDir='column'>
                { (medicinetype == "Injection" ||
                  medicinetype == "Tablet" ||
                  medicinetype == "Capsule") || medicinetype == "Nebulization" || medicinetype == "Inhaler" ? (
                  <Text fontSize="0.875rem" fontWeight="600" my="0.5rem">
                    Duration
                  </Text>
                  ) : medicinetype == "Ointment" ? (
                    <Text fontSize="0.875rem" fontWeight="600" my="0.5rem">
                      Application Duration
                    </Text>
                  ) : (
                    medicinetype == "IVFluids" && 
                    <Text fontSize="0.875rem" fontWeight="600" my="0.5rem">
                      Infusion Duration
                    </Text>
                  )
                }
                <Flex w='100%'>
                {(medicinetype == "Injection" ||
                  medicinetype == "Tablet" ||
                  medicinetype == "Capsule") && (
                  <>
                    {/* <Divider my="10px" /> */}
                    {/* <Box display="flex" flexDir="row"> */}
                      <Box width={medicinetype == "Injection" ? "50%" : "100%"}>
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Duration"
                          options={["Days", "Weeks", "Months", "Years"]}
                          onClick={handleDurationUnit}
                          // defaultOption={durationUnit}
                          defaultOption="Days"
                        />
                      </Box>
                      <Box width={medicinetype == "Injection" ? "50%" : "100%"}>
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Interval Value"
                          options={["1", "2", "3", "4", "5", "6", "7"]}
                          onClick={handleDurationValue}
                          // defaultOption={durationValue}
                          defaultOption="5"
                        />
                      </Box>
                    {/* </Box> */}
                    {/* <Divider my="10px" /> */}
                  </>
                )}

                {medicinetype == "Injection" && (
                  <>
                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Route of Administration"
                      options={[
                        "Intravenous (IV)",
                        "Intramuscular (IM)",
                        "Subcutaneous (SC)",
                      ]}
                      onClick={handleRouteOfAdministration}
                    />
                    <Box w='50%'>
                      <PrimaryInput
                        variant={"bothSide"}
                        onChange={handleTiming}
                        inputPlace="Timing"
                      />
                    </Box>
                  </>
                )}

                {(medicinetype == "Ointment" || medicinetype == "Cream" || medicinetype == "Gel") && (
                  <>
                    {/* <Divider my="10px" /> */}
                    {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                      Application Duration
                    </Text> */}
                    {/* <Box display="flex" flexDir="row"> */}
                      <Box width="100%">
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Duration"
                          options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
                          onClick={handleDurationUnit}
                          // defaultOption={durationUnit}
                          defaultOption="Days"
                        />
                      </Box>
                      <Box width="100%">
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Interval Value"
                          options={["1", "2", "3", "4", "5", "6", "7"]}
                          onClick={handleDurationValue}
                          // defaultOption={durationValue}
                          defaultOption="5"
                        />
                      </Box>
                    {/* </Box> */}

                    {/* <Divider my="10px" /> */}

                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Quantity"
                      options={[
                        "Pea-sized",
                        "Thin layer",
                        "Fingertip unit (FTU)",
                        "Half a fingertip",
                      ]}
                      onClick={handleQuantity}
                      value={quantity || ""}
                      defaultOption={quantity}
                    />
                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Area of Application"
                      options={["On Scalp", "On Skin", "On Wound", "On Hair"]}
                      onClick={(value) => setAreaOfApplication(value)}
                      value={areaOfApplication || ""}
                      defaultOption={areaOfApplication}
                    />
                  </>
                )}

                {medicinetype == "Nebulization" && (
                  <>
                    {/* <Divider my="10px" /> */}
                    {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                      Duration
                    </Text> */}

                    {/* <Box display="flex" flexDir="row"> */}
                      <Box width="100%">
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Duration"
                          options={["Days", "Weeks", "Months", "Years"]}
                          onClick={handleDurationUnit}
                          // defaultOption={durationUnit}
                          defaultOption="Days"
                        />
                      </Box>
                      <Box width="100%">
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Interval Value"
                          options={["1", "2", "3", "4", "5", "6", "7"]}
                          onClick={handleDurationValue}
                          // defaultOption={durationValue}
                          defaultOption="5"
                        />
                      </Box>
                    {/* </Box> */}
                    {/* <Divider my="10px" /> */}

                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Diluent"
                      options={["Normal saline", "Distilled water", "3% saline"]}
                      onClick={handleDiluent}
                    />
                  </>
                )}

                {medicinetype == "IVFluids" && (
                  <>
                    {/* <Divider my="10px" /> */}
                    {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                      Infusion Duration
                    </Text> */}

                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Infusion frequency"
                      options={["1", "2", "3", "4", "5", "6", "7"]}
                      onClick={handleDurationValue}
                      // defaultOption={durationValue}
                      defaultOption="5"
                    />
                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Infusion Duration"
                      options={["Days", "Weeks", "Months", "Years"]}
                      onClick={handleDurationUnit}
                      // defaultOption={durationUnit}
                      defaultOption="Days"
                    />

                    {/* <Divider my="10px" /> */}

                    <PrimaryInput
                      variant={"bothSide"}
                      onChange={handleAdditives}
                      inputPlace="Additives"
                    />
                  </>
                )}

                {medicinetype == "Inhaler" && (
                  <>
                    {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                      Duration
                    </Text> */}

                    {/* <Box display="flex" flexDir="row"> */}
                      <Box width="100%">
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Duration"
                          options={["Days", "Weeks", "Months", "Years"]}
                          onClick={handleDurationUnit}
                          // defaultOption={durationUnit}
                          defaultOption="Days"
                        />
                      </Box>
                      <Box width="100%">
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Interval Value"
                          options={["1", "2", "3", "4", "5", "6", "7"]}
                          onClick={handleDurationValue}
                          // defaultOption={durationValue}
                          defaultOption="5"
                        />
                      </Box>
                    {/* </Box> */}
                    {/* <Divider my="10px" /> */}
                  </>
                )}

                
                {/* <MonthYearPicker
                  placeholderProp="Medicine Expiry"
                  value={medicineexpirydate}
                  onDateChange={handleMonthYearChange}
                  datePickerInputStyle={{ borderRadius: "0" }}
                  minYear={moment().year()}
                /> */}
                </Flex>
              </Flex>
              <Flex justifyContent="space-between" mt='0.75rem' alignItems='center'>
                {/* COMMENTED OUT - Replaced with dropdown */}
                {/* <CheckboxGroup
                  colorScheme="green"
                  onChange={handlemedicinetime}
                  value={timeValues}
                >
                  <Stack spacing={2} direction="row">
                    <Checkbox value="morning">Morning</Checkbox>
                    <Checkbox value="afternoon">Afternoon</Checkbox>
                    <Checkbox value="night">Night</Checkbox>
                  </Stack>
                </CheckboxGroup> */}

                {/* Dropdown for Meal Timing */}
                <Box width='180px'>
                  <DropdownInput
                    variant="bothSide"
                    dropDownPlace="Meal Timing"
                    arrowCSS={{pr:0}}
                    options={[
                      "1-0-0",
                      "0-1-0",
                      "0-0-1",
                      "1-1-0",
                      "1-0-1",
                      "0-1-1",
                      "1-1-1",
                      "0-0-0"
                      // "1-0-0 (Morning)",
                      // "0-1-0 (Afternoon)",
                      // "0-0-1 (Night)",
                      // "1-1-0 (Morning & Afternoon)",
                      // "1-0-1 (Morning & Night)",
                      // "0-1-1 (Afternoon & Night)",
                      // "1-1-1 (All three)",
                      // "0-0-0 (None)"
                    ]}
                    onClick={(value) => {
                      if (value) {
                        const { morning, afternoon, night } = parseMealTiming(value);
                        setMorning(morning ? "1" : "0");
                        setAfternoon(afternoon ? "1" : "0");
                        setEvening(night ? "1" : "0");
                      }
                    }}
                    value={getMealTimingLabel(String(morning) === "1" ? 1 : 0, String(afternoon) === "1" ? 1 : 0, String(setnight) === "1" ? 1 : 0)}
                  />
                </Box>
                <Text fontWeight='600' whiteSpace='nowrap'>- Or -</Text>
                {/* <Text
                  fontWeight="600"
                  width="50%"
                  display="flex"
                  justifyContent="center"
                  whiteSpace="nowrap"
                  my='0.5rem'
                >
                  - Or -
                </Text> */}

                <Flex width="100%">
    <Box width='150px'>

                  <DropdownInput
                    variant="bothSide"
                    dropDownPlace="Frequency"
                    options={["Hours", "Daily", "Weekly"]}
                    onClick={handleFrequencyUnit}
                    value={medicineFreqUnit}
                  />
                </Box>
                <Box width='80px'>
                  <DropdownInputForVitals
                    variant="bothSide"
                    dropDownPlace="Value"
                    options={["1", "2", "3", "4", "8"]}
                    onClick={handleFrequencyValue}
                    value={medicineFreqValue}
                    readOnly=""
                    inputValueProp={medicineFreqValue}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value) {
                        setTimeValues([]);
                        setMorning(0);
                        setAfternoon(0);
                        setNight(0);
                      }
                      setMedicineFreqValue(value);
                    }}
                    maxLength={2}
                  />

                </Box>
                </Flex>
                <Box width='50%'>
                  {/* OLD FOOD TIMING RADIOS - COMMENTED OUT FOR TOPICAL SUPPORT
                  <RadioGroup
                    w='100%'
                    colorScheme="green"
                    onChange={handlemedicinetimebeforeafter}
                    value={foodTiming}
                  >
                    <Stack spacing={2} direction="row">
                      <Radio value="beforefood">Before Food</Radio>
                      <Radio value="afterfood">After Food</Radio>
                    </Stack>
                  </RadioGroup>
                  END OLD FOOD RADIOS */}

                  {/* CONDITIONAL TIMING: TOPICAL VS FOOD */}
                  {(medicinetype === "Cream" || medicinetype === "Ointment" || medicinetype === "Gel") ? (
                    <Box w='100%'>
                      {/* <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Product Quantity"
                        options={["1", "2", "3", "4"]}
                        onClick={(value) => setProductQuantity(value)}
                        value={productQuantity || "1"}
                      /> */}

                      {/* <Text fontSize="sm" mb={1} mt={2}>Application Timing</Text> */}
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Application Timing"
                        options={[
                          "After Bath",
                          "Before Bath",
                          "After Sun",
                          "Before Sun",
                          "Time-based",
                        ]}
                        onClick={(value) => {
                          setFoodTiming(value);
                        }}
                        value={foodTiming}
                      />
                    </Box>
                  ) : (
                    <RadioGroup
                      w='100%'
                      colorScheme="green"
                      onChange={handlemedicinetimebeforeafter}
                      value={foodTiming}
                    >
                      <Stack spacing={2} direction="row">
                        <Radio value="beforefood">Before Food</Radio>
                        <Radio value="afterfood">After Food</Radio>
                      </Stack>
                    </RadioGroup>
                  )}
                </Box>
              </Flex>
                {/* <Box display="flex" w='100%' alignItems='center' gap='0.75rem'> */}
              </Box>
              <Box>
                {/* <Box w="100%" pos="relative" cursor="pointer">
                  <PrimaryInput
                    inputPlace="Prescribed by"
                    variant="defaultSide"
                    inputValue={prescribedby}
                    onChange={(e) =>
                      handleSurgeonNameChange(
                        handleAlphaDotAndSpace(e.target.value, 50),
                      )
                    }
                    onClick={() => listOfSurgeonNames(false)}
                    inputIdProp={"DoctorNameInAdd"}
                    boolProp={boolValForSuggestions}
                  />
                  <Image
                    top="33%"
                    right="6.5%"
                    w="15px"
                    onClick={() => listOfSurgeonNames(true)}
                    pos="absolute"
                    src="/assets/imgs/double-arrow.png"
                  />
                </Box> */}
                {showDocNamesDropdown && suggestions.length > 0 && (
                  <Menu isOpen={true}>
                    <MenuButton
                      as={Box}
                      w="100%"
                      display="block"
                      pos="relative"
                      zIndex="999"
                    >
                      <Box
                        pos="absolute"
                        top="100%"
                        left="0"
                        w="100%"
                        bg="white"
                        borderTop="none"
                        border="1px solid #E6E7E9"
                        borderRadius="0 0 12px 12px"
                      />
                    </MenuButton>
                    <MenuList
                      w="100%"
                      borderRadius="0 0 12px 12px"
                      zIndex="999"
                      bg="white"
                      maxH="150px"
                      overflow="hidden auto"
                    >
                      {suggestions.map((suggestion, index) => (
                        <MenuItem
                          key={index}
                          onClick={() => handleSelect(suggestion)}
                          cursor="pointer"
                          p="1rem"
                          py="0.5rem"
                          borderBottom="1px solid #E6E7E9"
                        >
                          <Text fontSize="0.875rem" fontWeight="500">
                            {suggestion.doctorname}
                          </Text>
                        </MenuItem>
                      ))}
                    </MenuList>
                  </Menu>
                )}
                {/* <PrimaryInput
                  inputPlace="Hospital name"
                  variant="downSide"
                  onChange={(e) =>
                    setHospitalname(handleAlphaNumericDotAndSpace(e.target.value))
                  }
                  inputValue={hospitalname}
                /> */}

                {/* <Textarea
                  mt='0.5rem'
                  borderRadius='10px'
                  placeholder="Instructions"
                  defaultValue={instructions}
                  onChange={handleInstructions}
                  inputValue={instructions}
                /> */}

                <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
                  <Box
                    as="form"
                    width='100%'
                    bg="white"
                    pt={"2px"}
                  >
                    <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
                      <Textarea
                        borderRadius='0'
                        // value={newMedicine.custommessage || ''}
                        value={instructions || ''}
                        onChange={(e) => {
                    handleInstructions(e.target.value);
                    setValue("textField", e.target.value); 
                  }}
                  //       onChange={(e) => {
                  //   handleNewMedicineChange("custommessage", e.target.value);
                  //   setValue("textField", e.target.value); 
                  // }}
                        height="100%"
                        padding="2"
                        resize="none"
                        // disabled={typing} // Disable when AI typing is true
                        style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                      />                      
                      {!instructions && (
                        <Text
                          position="absolute"
                          bottom="2"
                          left="50%"
                          transform="translateX(-50%)"
                          fontSize="sm"
                          color="gray.500"
                          w={{ base: "100%", md: "unset" }}
                          textAlign={{ base: "center", md: "unset" }}
                        >
                          {placeholder}
                        </Text>
                      )}
                    </Box>
                    
                  </Box>
                </Box>
                {/* <Box mt=".5rem">
                  <Checkbox
                    colorScheme="green"
                    sx={{
                      ".chakra-checkbox__control": {
                        width: "20px",
                        height: "20px",
                        borderRadius: "5px",
                      },
                    }}
                    onChange={handleIsCurrent}
                  >
                    Current
                  </Checkbox>
                </Box> */}
              </Box>
              {/* Audio & Language Controls Row - Highlighted Section */}
                    <Box
                      bg="#f8f9fa"
                      border="1px solid #e9ecef"
                      borderRadius="8px"
                      p="1rem"
                      mt="1rem"
                      // mb="1rem"
                    >
                      <Flex
                        alignItems="center"
                        justifyContent="space-around"
                        // justifyContent="space-between"
                        gap="1rem"
                        flexWrap={{ base: "wrap", md: "nowrap" }}
                      >
                        {/* Input Language Dropdown */}
                        <Box flex="1" minW="120px">
                          <DropdownWithMultiLingual 
                            menuList={{pos:'relative', right:'75px'}}
                            placeholder="English"
                            onClick={handleChangeLanguage}
                            options={languageOptions.map(value => ({ value }))}
                            title="Input Language"
                          />
                        </Box>
                        
                        {/* Audio Controls and Wave Display */}
                        <Box 
                    flex="1"
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    gap="0.75rem"
                    minH="50px"
                    px="1rem"
                  >
                    <GPUChatAudioManagerSpeechMode
                      transcriber={activeTranscriber}
                      mode={mode}
                      setPlaceholder={setPlaceholder}
                      setTyping={setTyping}
                      onRecordingStateChange={handleRecordingStateChange} 
                    />
              
                    {isRecording && (
                      <Box flex="1" minW="180px" maxW="250px">
                        <AudioDisplayForClutter
                          borderRadius="lg"
                          stream={stream}
                          width="100%"
                        />
                      </Box>
                    )}
                  </Box>
              
                        {/* Output Language Dropdown */}
                        <Box flex="1" minW="120px">
                          <DropdownWithMultiLingual 
                            menuList={{pos:'relative', right:'75px'}}
                            placeholder="English"
                            onClick={handleChangeOutputLanguage}
                            options={languageOptions.map(value => ({ value }))}
                            title="Output Language"
                          />
                        </Box>
              
                        {/* AI Correction Button */}
                        <Box
                          as="button"
                          type="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="40px"
                          h="40px"
                          p="8px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          cursor={textFieldValue ? "pointer" : "not-allowed"}
                          opacity={textFieldValue ? 1 : 0.5}
                          pointerEvents={textFieldValue ? "auto" : "none"}
                          onClick={() => textFieldValue && correctOrders("add")}
                          flexShrink="0"
                          bg="white"
                          _hover={textFieldValue ? { bg: "#f0f0f0" } : {}}
                        >
                          <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                        </Box>
                      </Flex>
                    </Box>
              {filenameArray.map((filename, indexToDelete) => (
                <Button
                  fontSize="14px"
                  fontWeight="500"
                  w="100%"
                  h="48px"
                  borderRadius="10px"
                  border="1px solid #E6E7E9"
                  display="flex"
                  justifyContent="space-between"
                  bg="white"
                  color="#1C4EC5"
                  sx={{ _hover: { bg: "none" } }}
                >
                  Document {indexToDelete + 1}
                  <Box as="span">
                    <Image src="/assets/imgs/delete.png" />
                  </Box>
                </Button>
              ))}
              <input
                type="file"
                id="file-upload"
                onChange={(e) => handleMedicationUpload(e)}
                ref={fileInputRef} // Set the ref for the file input
                style={{ display: "none" }} // Hide the file input
              />
            </Stack>
          </Box>
        </>
      }
      modalFooterBtn={
        <>
        {/* <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>        
          <GPUChatAudioManager
              transcriber={activeTranscriber}
              setPlaceholder={setPlaceholder}
              setTyping={setTyping}
              // onTranscribedText={handleTranscribedText}  // This is the key addition
                onTranscribedText={(text) => {
            handleInstructions(text);
            setValue("textField", text);
          }}
            />
            <Box
              as="button"
              type="button" 
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="auto"
              p="10px"
              mr='10px'
              display="flex"
              justifyContent="center"
              alignItems="center"
              cursor={textFieldValue ? "pointer" : "not-allowed"}
              opacity={textFieldValue ? 1 : 0.5}
              pointerEvents={textFieldValue ? "auto" : "none"}
              onClick={() => textFieldValue && correctOrders("add")}
            >
              <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
            </Box>
        </Box> */}
          <PrimaryButton buttonText="Add Medication" onClick={addmedicine} />
        </>
      }
    />

    <DynamicModal
      ref={editmedications}
      modalHeader="Edit Medication"
      modalWidth={{base:'100%', md: 'calc(100vw - 10%)'}}
      modalBody={
        <>
          <Box display="flex" flexDir="column" gap="20px">
            <Stack>
              <Flex>
                <InputGroup>
                  <Input
                    pr="4.5rem" // Padding right to make room for the icon
                    type="text"
                    placeholder="Medicine name*"
                    // value={medicinename}
                    value={medicinename.charAt(0).toUpperCase() + medicinename.slice(1)}
                    sx={{
                      height: "48px",
                      borderRadius: "10px 0 0 10px",
                      _hover: {
                        border: "2px solid",
                        borderColor: COLORS.INPUT_FOCUS_DARK,
                        outline: "none",
                        bg: "none",
                        _focus: {
                          borderRadius: "10px",
                          borderColor: COLORS.INPUT_FOCUS_DARK,
                          outline: "none",
                        },
                        _focusVisible: { borderColor: "none" },
                      },
                    }}
                    onChange={handlemedicinename}
                    maxLength={80}
                  />
                  <InputRightElement width="4.5rem">
                    <Box
                      as="button"
                      h="1.75rem"
                      bg="none"
                      pt="8px"
                      onClick={() => document.getElementById("file-upload").click()}
                      sx={{ _hover: { bg: "none" } }}
                    >
                      <Image src="/assets/svgs/image-search-blue.svg" />
                    </Box>
                    <input
                      type="file"
                      id="file-upload"
                      style={{ display: "none" }}
                      //onChange={(e) => setFile(e.target.files[0])}
                      onChange={handleimageselection}
                    />
                  </InputRightElement>
                </InputGroup>
                <PrimaryInput
                  variant={"bothSide"}
                  onChange={handleManufacturer}
                  inputPlace="Manufacturer"
                  defaultValue={manufacturer}
                  inputValue={manufacturer}
                />
                  <PrimaryInput
                    variant="bothSide"
                    inputValue={Composition}
                    onChange={(event) => setComposition(event.target.value)}
                    inputPlace="Medicine Composition*"
                    // isDisabled
                  />
                  <Box
                    as="button"
                    type="button"
                    border="1px solid #E6E7E9"
                    // borderRadius="full"
                    width={{ base: "100%", md: "10%" }}
                    // w="40px"
                    // h="40px"
                    p="8px"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                    // opacity={medicineTextFieldValue ? 1 : 0.5}
                    // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                    onClick={() => {
                    if (isChatbotAllowed()) {
                      fetchEditComposition(medicinename);
                    } else {
                      showErrorToast("Please upgrade your subscription to use this feature");
                    }
                  }}
                  isDisabled={!isChatbotAllowed()}
                  title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                    bg="white"
                    // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                  >
                    <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                  </Box>
                  {/* <PrimaryButton
                    buttonText="Fetch"
                    verticalAlign="bottom"
                    variant="grayBtn"
                    btnStyle={{
                      w: "15%",
                      color: COLORS.PRIMARY_COLOR,
                      verticalAlign: "bottom",
                      ml: "4px",
                      mb: "0px",
                      h: "48px",
                      m: "0",
                      borderRadius: "0 10px 10px 0",
                      opacity: isChatbotAllowed() ? 1 : 0.6,
                      cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                    }}
                    onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchEditComposition(medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                    // onClick={() => fetchComposition(medicinename)}
                    // isDisabled={false}
                  /> */}
              </Flex>
              {/* <Divider /> */}
              <RadioGroup
                // mt="1rem"
                // defaultValue={medicineTypeRadio}
                // defaultValue={medicinetype}
                value={medicinetype}
                // onChange={handlemedicinetypechange}
                onChange={(value) => {
                  console.log("Radio selected:", value);
                  handlemedicinetypechange(value, "radio");
                }}
              >
                <Stack direction="row" alignItems='center' spacing={4} wrap="wrap">
                  <Radio colorScheme="green" value="Tablet">Tablet</Radio>
                  <Radio colorScheme="green" value="Capsule">Capsule</Radio>
                  <Radio colorScheme="green" value="Syrup">Syrup</Radio>
                  <Radio colorScheme="green" value="Drops">Drops</Radio>
                  <Radio colorScheme="green" value="Injection">Injection</Radio>
                  <Radio colorScheme="green" value="Nebulization">Nebulization</Radio>
                  <Radio colorScheme="green" value="IVFluids">IV Fluids</Radio>
                  <Radio colorScheme="green" value="Inhaler">Inhaler</Radio>
                  <Radio colorScheme="green" value="Sachet">Sachet</Radio>
                  <Radio colorScheme="green" value="Ointment">Ointment</Radio>
                  <Radio colorScheme="green" value="Cream">Cream</Radio>
                  <Radio colorScheme="green" value="Gel">Gel</Radio>

                  {/* <Radio colorScheme="green" value="Respules">Respules</Radio>
                  <Radio colorScheme="green" value="Suspension">Suspension</Radio>
                  <Radio colorScheme="green" value="Foam">Foam</Radio>
                  <Radio colorScheme="green" value="Suppository">Suppository</Radio>
                  <Radio colorScheme="green" value="EA">EA</Radio>
                  <Radio colorScheme="green" value="Device">Device</Radio>
                  <Radio colorScheme="green" value="Box">Box</Radio>
                  <Radio colorScheme="green" value="Spray">Spray</Radio>
                  <Radio colorScheme="green" value="Lotion">Lotion</Radio>
                  <Radio colorScheme="green" value="Tube">Tube</Radio>
                  <Radio colorScheme="green" value="Gargle">Gargle</Radio>
                  <Radio colorScheme="green" value="Powder">Powder</Radio>
                  <Radio colorScheme="green" value="Soap">Soap</Radio>
                  <Radio colorScheme="green" value="Aerosol">Aerosol</Radio>
                  <Radio colorScheme="green" value="Shampoo">Shampoo</Radio>
                  <Radio colorScheme="green" value="Topical Cleanser">Topical Cleanser</Radio>
                  <Radio colorScheme="green" value="Custom">Custom</Radio> */}
                <Text>-Or-</Text>
                <Box mx='1rem'>
                  <DropdownInput
                          variant="bothSide"
                          dropDownPlace="More Medicine Types"
                          options={additionalMedicineTypes}
                          onClick={(value) => {
                            console.log("Dropdown selected:", value);
                            handleDropdownMedTypeChange(value);
                          }}
                          value={dropdownMedType}
                          defaultOption={dropdownMedType || "Select more types"}
                          // Add a clear prop if your DropdownInput component supports it
                          clearValue={() => setDropdownMedType("")}
                        />

                {/* <DropdownInput
  variant="bothSide"
  dropDownPlace="More Medicine Types"
  options={additionalMedicineTypes}
  onClick={(value) => handleDropdownMedTypeChange(value)}
  value={selectedValue}
  defaultOption={selectedValue || "Select more types"}
/> */}
                </Box>
                </Stack>
              </RadioGroup>
              {/* <Divider /> */}
              <Box>
                <Flex>
                <PrimaryInput
                  variant={"bothSide"}
                  onChange={handleDrugClass}
                  inputPlace="Drug Class*"
                  defaultValue={drugClass}
                  inputValue={drugClass}
                />
                <PrimaryInput
                  variant={"bothSide"}
                  onChange={handleTherapeuticCategory}
                  inputPlace="Therapeutic category"
                  defaultValue={therapeutic}
                  inputValue={therapeutic}
                />

                {/* newly added code */}
                {medicinetype == "Tablet" || medicinetype == "Capsule" || medicinetype == "Suppository" || medicinetype == "Powder" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "mcg", value: "mcg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength*"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Inhaler" || medicinetype === "Spray" || medicinetype === "Aerosol" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "puffs", value: "puffs" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
    ]}
    placeholderProp="Volume"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Syrup" ||
    medicinetype === "IVFluids" ||
    medicinetype === "Nebulization" ||
    medicinetype === "Drops" ||
    medicinetype === "Injection" ||
    medicinetype === "Suspension" ||
    medicinetype === "Respules" ||
    medicinetype === "Gargle" ||
    medicinetype === "Shampoo" ||
    medicinetype === "Topical Cleanser" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "ml", value: "ml" }]}
    placeholderProp="Volume"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Ointment" ||
    medicinetype === "Cream" ||
    medicinetype === "Gel" ||
    medicinetype === "Foam" ||
    medicinetype === "Lotion" ||
    medicinetype === "Tube" ||
    medicinetype === "Soap" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "grms", value: "grms" }, { label: "ml", value: "ml" }]}
    placeholderProp="Weight/Volume"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "EA" || medicinetype === "Device" || medicinetype === "Box" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "each", value: "each" }]}
    placeholderProp="Count"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Sachet" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : (
  // Default case for CUSTOM and any unexpected types
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
      { label: "puffs", value: "puffs" },
      { label: "each", value: "each" },
    ]}
    placeholderProp={medicinetype === "Custom" ? "Custom Unit" : "Strength"}
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
)}

{medicinetype == "IVFluids" && (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "ml/hr", value: "ml/hr" },
      { label: "ml/min", value: "ml/min" },
    ]}
    handleInputChange={(e) =>
      setRateOfInfusionValue(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    placeholderProp={"Rate of Infusion"}
    onSelect={handleRateOfInfusionUnit}
    maxLength="6"
  />
)}

                {/* existing code for edit */}
                {/* {medicinetype == "Tablet" || medicinetype == "Capsule" ? (
                  <MiniDropdownInput
                    variant="bothSide"
                    options={[
                      { label: "mg", value: "mg" },
                      { label: "mcg", value: "mcg" },
                      { label: "g", value: "g" },
                    ]}
                    placeholderProp={
                      medicinetype == "Syrup" ||
                      medicinetype == "Injection" ||
                      medicinetype == "Nebulization" ||
                      medicinetype == "IVFluids" ||
                      medicinetype == "Drops"
                        ? "Volume"
                        : "Strength"
                    }
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(
                        validationOfNumberWithOnly1Decimal(e.target.value),
                      )
                    }
                    inputVal={dosage}
                    defaultOptionProp={dosageunit}
                    maxLength="6"
                  />
                ) : medicinetype === "Inhaler" ? (
                  <MiniDropdownInput
                    variant="bothSide"
                    options={[
                      { label: "puffs", value: "puffs" },
                      { label: "ml", value: "ml" },
                      { label: "grms", value: "grms" },
                    ]}
                    placeholderProp={
                      medicinetype == "Inhaler" ? "Volume" : "Strength"
                    }
                    isDisabled={medicinetype == "Dosage" ? true : false}
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(
                        validationOfNumberWithOnly1Decimal(e.target.value),
                      )
                    }
                    inputVal={dosage}
                    defaultOptionProp={dosageunit}
                    maxLength="6"
                  />
                ) : medicinetype === "Syrup" ||
                  medicinetype === "IVFluids" ||
                  medicinetype === "Nebulization" ||
                  medicinetype === "Drops" ||
                  medicinetype === "Injection" ? (
                  <MiniDropdownInput
                    variant="bothSide"
                    options={[{ label: "ml", value: "ml" }]}
                    placeholderProp={
                      medicinetype == "Syrup" ||
                      medicinetype == "Injection" ||
                      medicinetype == "Nebulization" ||
                      medicinetype == "IVFluids" ||
                      medicinetype == "Drops"
                        ? "Volume"
                        : "Strength"
                    }
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(
                        validationOfNumberWithOnly1Decimal(e.target.value),
                      )
                    }
                    inputVal={dosage}
                    defaultOptionProp={dosageunit}
                    maxLength="6"
                  />
                ) : (
                  <MiniDropdownInput
                    variant="bothSide"
                    options={[
                      { label: "mg", value: "mg" },
                      { label: "ml", value: "ml" },
                      { label: "grms", value: "grms" },
                    ]}
                    placeholderProp={
                      medicinetype == "Syrup" ||
                      medicinetype == "Injection" ||
                      medicinetype == "Nebulization" ||
                      medicinetype == "IVFluids" ||
                      medicinetype == "Drops"
                        ? "Volume"
                        : "Strength"
                    }
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(
                        validationOfNumberWithOnly1Decimal(e.target.value),
                      )
                    }
                    inputVal={dosage}
                    defaultOptionProp={dosageunit}
                    maxLength="6"
                  />
                )}

                {medicinetype == "IVFluids" && (
                  <MiniDropdownInput
                    variant="bothSide"
                    options={[
                      { label: "ml/hr", value: "ml/hr" },
                      { label: "ml/min", value: "ml/min" },
                    ]}
                    handleInputChange={(e) =>
                      setRateOfInfusionValue(
                        validationOfNumberWithOnly1Decimal(e.target.value),
                      )
                    }
                    placeholderProp={"Rate of Infusion"}
                    onSelect={handleRateOfInfusionUnit}
                    maxLength="6"
                  />
                )} */}

                <DropdownInput
                  variant="bothSide"
                  dropDownPlace={
                    medicinetype == "Ointment" || medicinetype === "Cream" || medicinetype === "Gel"
                      ? "Application Frequency"
                      : medicinetype == "Nebulization" ||
                          medicinetype == "Inhaler" ||
                          medicinetype == "IVFluids"
                        ? "Frequency"
                        : "Consumption Quantity"
                  }
                  // options={["0.5", "1", "2", "3", "4"]}
                  options={(medicinetype === "Ointment" || medicinetype === "Cream" || medicinetype === "Gel") ? ["1", "2", "3", "4"] : ["0.5", "1", "2", "3", "4"]}
                  onClick={handleconsumptionfrequencychange}
                  value={frequency || "1"}
                  defaultOption={frequency || "1"}
                />
              </Flex>
                {/* <Divider my="10px" /> */}
              <Flex flexDir='column'>
                { (medicinetype == "Injection" ||
                  medicinetype == "Tablet" ||
                  medicinetype == "Capsule") || medicinetype == "Nebulization" || medicinetype == "Inhaler" ? (
                  <Text fontSize="0.875rem" fontWeight="600" my="0.5rem">
                    Duration
                  </Text>
                  ) : medicinetype == "Ointment" ? (
                    <Text fontSize="0.875rem" fontWeight="600" my="0.5rem">
                      Application Duration
                    </Text>
                  ) : (
                    medicinetype == "IVFluids" && 
                    <Text fontSize="0.875rem" fontWeight="600" my="0.5rem">
                      Infusion Duration
                    </Text>
                  )
                }
                <Flex w='100%'>
                {(medicinetype == "Injection" ||
                  medicinetype == "Tablet" ||
                  medicinetype == "Capsule") && (
                  <>
                    {/* <Divider my="10px" /> */}
                    {/* <Box display="flex" flexDir="row"> */}
                      <Box width={medicinetype == "Injection" ? "50%" : "100%"}>
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Duration"
                          options={["Days", "Weeks", "Months", "Years"]}
                          onClick={handleDurationUnit}
                          // defaultOption={durationUnit}
                          defaultOption="Days"
                        />
                      </Box>
                      <Box width={medicinetype == "Injection" ? "50%" : "100%"}>
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Interval Value"
                          options={["1", "2", "3", "4", "5", "6", "7"]}
                          onClick={handleDurationValue}
                          // defaultOption={durationValue}
                          defaultOption="5"
                        />
                      </Box>
                    {/* </Box> */}
                    {/* <Divider my="10px" /> */}
                  </>
                )}

                {medicinetype == "Injection" && (
                  <>
                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Route of Administration"
                      options={[
                        "Intravenous (IV)",
                        "Intramuscular (IM)",
                        "Subcutaneous (SC)",
                      ]}
                      onClick={handleRouteOfAdministration}
                    />
                    <Box w='50%'>
                      <PrimaryInput
                        variant={"bothSide"}
                        onChange={handleTiming}
                        inputPlace="Timing"
                      />
                    </Box>
                  </>
                )}

                {(medicinetype == "Ointment" || medicinetype == "Cream" || medicinetype == "Gel") && (
                  <>
                    {/* <Divider my="10px" /> */}
                    {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                      Application Duration
                    </Text> */}
                    {/* <Box display="flex" flexDir="row"> */}
                      <Box width="100%">
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Duration"
                          options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
                          onClick={handleDurationUnit}
                          // defaultOption={durationUnit}
                          defaultOption="Days"
                        />
                      </Box>
                      <Box width="100%">
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Interval Value"
                          options={["1", "2", "3", "4", "5", "6", "7"]}
                          onClick={handleDurationValue}
                          // defaultOption={durationValue}
                          defaultOption="5"
                        />
                      </Box>
                    {/* </Box> */}

                    {/* <Divider my="10px" /> */}

                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Quantity"
                      options={[
                        "Pea-sized",
                        "Thin layer",
                        "Fingertip unit (FTU)",
                        "Half a fingertip",
                      ]}
                      onClick={handleQuantity}
                      value={quantity || ""}
                      defaultOption={quantity}
                    />
                    <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Area of Application"
                          options={["On Scalp", "On Skin", "On Wound", "On Hair"]}
                          onClick={(value) => setAreaOfApplication(value)}
                          value={areaOfApplication || ""}
                          defaultOption={areaOfApplication}
                        />
                    {/* <PrimaryInput
                      variant={"bothSide"}
                      onChange={handleAreaOfApplication}
                      inputPlace="Area of Application"
                    /> */}
                  </>
                )}

                {medicinetype == "Nebulization" && (
                  <>
                    {/* <Divider my="10px" /> */}
                    {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                      Duration
                    </Text> */}

                    {/* <Box display="flex" flexDir="row"> */}
                      <Box width="100%">
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Duration"
                          options={["Days", "Weeks", "Months", "Years"]}
                          onClick={handleDurationUnit}
                          // defaultOption={durationUnit}
                          defaultOption="Days"
                        />
                      </Box>
                      <Box width="100%">
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Interval Value"
                          options={["1", "2", "3", "4", "5", "6", "7"]}
                          onClick={handleDurationValue}
                          // defaultOption={durationValue}
                          defaultOption="5"
                        />
                      </Box>
                    {/* </Box> */}
                    {/* <Divider my="10px" /> */}

                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Diluent"
                      options={["Normal saline", "Distilled water", "3% saline"]}
                      onClick={handleDiluent}
                    />
                  </>
                )}

                {medicinetype == "IVFluids" && (
                  <>
                    {/* <Divider my="10px" /> */}
                    {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                      Infusion Duration
                    </Text> */}

                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Infusion frequency"
                      options={["1", "2", "3", "4", "5", "6", "7"]}
                      onClick={handleDurationValue}
                      // defaultOption={durationValue}
                      defaultOption="5"
                    />
                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Infusion Duration"
                      options={["Days", "Weeks", "Months", "Years"]}
                      onClick={handleDurationUnit}
                      // defaultOption={durationUnit}
                      defaultOption="Days"
                    />

                    {/* <Divider my="10px" /> */}

                    <PrimaryInput
                      variant={"bothSide"}
                      onChange={handleAdditives}
                      inputPlace="Additives"
                    />
                  </>
                )}

                {medicinetype == "Inhaler" && (
                  <>
                    {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                      Duration
                    </Text> */}

                    {/* <Box display="flex" flexDir="row"> */}
                      <Box width="100%">
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Duration"
                          options={["Days", "Weeks", "Months", "Years"]}
                          onClick={handleDurationUnit}
                          // defaultOption={durationUnit}
                          defaultOption="Days"
                        />
                      </Box>
                      <Box width="100%">
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Interval Value"
                          options={["1", "2", "3", "4", "5", "6", "7"]}
                          onClick={handleDurationValue}
                          // defaultOption={durationValue}
                          defaultOption="5"
                        />
                      </Box>
                    {/* </Box> */}
                    {/* <Divider my="10px" /> */}
                  </>
                )}

                
                {/* <MonthYearPicker
                  placeholderProp="Medicine Expiry"
                  value={medicineexpirydate}
                  onDateChange={handleMonthYearChange}
                  datePickerInputStyle={{ borderRadius: "0" }}
                  minYear={moment().year()}
                /> */}
                </Flex>
              </Flex>
              <Flex justifyContent="space-between" mt='0.75rem' alignItems='center'>
                {/* COMMENTED OUT - Replaced with dropdown */}
                {/* <CheckboxGroup
                  colorScheme="green"
                  onChange={handlemedicinetime}
                  defaultValue={timeValues}
                >
                  <Stack spacing={2} direction="row">
                    <Checkbox value="morning">Morning</Checkbox>
                    <Checkbox value="afternoon">Afternoon</Checkbox>
                    <Checkbox value="night">Night</Checkbox>
                  </Stack>
                </CheckboxGroup> */}

                {/* Dropdown for Meal Timing */}
                <Box width='180px'>
                  <DropdownInput
                    variant="bothSide"
                    dropDownPlace="Meal Timing"
                    arrowCSS={{pr:0}}
                    options={[
                      "1-0-0",
                      "0-1-0",
                      "0-0-1",
                      "1-1-0",
                      "1-0-1",
                      "0-1-1",
                      "1-1-1",
                      "0-0-0"
                      // "1-0-0 (Morning)",
                      // "0-1-0 (Afternoon)",
                      // "0-0-1 (Night)",
                      // "1-1-0 (Morning & Afternoon)",
                      // "1-0-1 (Morning & Night)",
                      // "0-1-1 (Afternoon & Night)",
                      // "1-1-1 (All three)",
                      // "0-0-0 (None)"
                    ]}
                    onClick={(value) => {
                      if (value) {
                        const { morning, afternoon, night } = parseMealTiming(value);
                        setMorning(morning ? "1" : "0");
                        setAfternoon(afternoon ? "1" : "0");
                        setEvening(night ? "1" : "0");
                      }
                    }}
                    value={getMealTimingLabel(String(morning) === "1" ? 1 : 0, String(afternoon) === "1" ? 1 : 0, String(setnight) === "1" ? 1 : 0)}
                  />
                </Box>
                <Text fontWeight='600' whiteSpace='nowrap'>- Or -</Text>

                {/* <Text
                  fontWeight="600"
                  width="50%"
                  display="flex"
                  justifyContent="center"
                  whiteSpace="nowrap"
                  my='0.5rem'
                >
                  - Or -
                </Text> */}

                <Flex width="100%">
    <Box width='150px'>

                  <DropdownInput
                    variant="bothSide"
                    dropDownPlace="Frequency"
                    options={["Hours", "Daily", "Weekly"]}
                     onClick={handleEditFrequencyUnit}
                    // onClick={handleFrequencyUnit}
                    value={medicineFreqUnit}
                  />
                </Box>
                <Box width='80px'>
                  <DropdownInputForVitals
                    variant="bothSide"
                    dropDownPlace="Value"
                    options={["1", "2", "3", "4", "8"]}
                    // onClick={handleFrequencyValue}
                    onClick={handleEditFrequencyValue}
                    value={medicineFreqValue}
                    readOnly=""
                    inputValueProp={medicineFreqValue}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value) {
                        setTimeValues([]);
                        setMorning(0);
                        setAfternoon(0);
                        setNight(0);
                      }
                      setMedicineFreqValue(value);
                    }}
                    maxLength={2}
                  />
                </Box>
                </Flex>
                <Box width='50%'>
                  {/* OLD FOOD TIMING RADIOS - COMMENTED OUT FOR TOPICAL SUPPORT
                  <RadioGroup
                    w='100%'
                    colorScheme="green"
                    onChange={handlemedicinetimebeforeafter}
                    value={foodTiming}
                  >
                    <Stack spacing={2} direction="row">
                      <Radio value="beforefood">Before Food</Radio>
                      <Radio value="afterfood">After Food</Radio>
                    </Stack>
                  </RadioGroup>
                  END OLD FOOD RADIOS */}

                  {/* CONDITIONAL TIMING: TOPICAL VS FOOD */}
                  {(medicinetype === "Cream" || medicinetype === "Ointment" || medicinetype === "Gel") ? (
                    <Box w='100%'>
                      {/* <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Product Quantity"
                        options={["1", "2", "3", "4"]}
                        onClick={(value) => setProductQuantity(value)}
                        value={productQuantity || "1"}
                      /> */}

                      {/* <Text fontSize="sm" mb={1} mt={2}>Application Timing</Text> */}
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Application Timing"
                        options={[
                          "After Bath",
                          "Before Bath",
                          "After Sun",
                          "Before Sun",
                          "Time-based",
                        ]}
                        onClick={(value) => {
                          setFoodTiming(value);
                        }}
                        value={foodTiming}
                      />

                      {/* <Box mt={2}>
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Area of Application"
                          options={["On Scalp", "On Skin", "On Wound", "On Hair"]}
                          onClick={(value) => setAreaOfApplication(value)}
                          value={areaOfApplication || ""}
                          defaultOption={areaOfApplication}
                        />
                      </Box> */}
                    </Box>
                  ) : (
                    <RadioGroup
                      w='100%'
                      colorScheme="green"
                      onChange={handlemedicinetimebeforeafter}
                      value={foodTiming}
                    >
                      <Stack spacing={2} direction="row">
                        <Radio value="beforefood">Before Food</Radio>
                        <Radio value="afterfood">After Food</Radio>
                      </Stack>
                    </RadioGroup>
                  )}
                </Box>
              </Flex>
                {/* <Box display="flex" w='100%' alignItems='center' gap='0.75rem'> */}
              </Box>
              <Box>
                {/* <Box w="100%" pos="relative" cursor="pointer">
                  <PrimaryInput
                    inputPlace="Prescribed by"
                    variant="defaultSide"
                    inputValue={prescribedby}
                    onChange={(e) =>
                      handleSurgeonNameChange(
                        handleAlphaDotAndSpace(e.target.value, 50),
                      )
                    }
                    onClick={() => listOfSurgeonNames(false)}
                    inputIdProp={"DoctorNameInAdd"}
                    boolProp={boolValForSuggestions}
                  />
                  <Image
                    top="33%"
                    right="6.5%"
                    w="15px"
                    onClick={() => listOfSurgeonNames(true)}
                    pos="absolute"
                    src="/assets/imgs/double-arrow.png"
                  />
                </Box> */}
                {showDocNamesDropdown && suggestions.length > 0 && (
                  <Menu isOpen={true}>
                    <MenuButton
                      as={Box}
                      w="100%"
                      display="block"
                      pos="relative"
                      zIndex="999"
                    >
                      <Box
                        pos="absolute"
                        top="100%"
                        left="0"
                        w="100%"
                        bg="white"
                        borderTop="none"
                        border="1px solid #E6E7E9"
                        borderRadius="0 0 12px 12px"
                      />
                    </MenuButton>
                    <MenuList
                      w="100%"
                      borderRadius="0 0 12px 12px"
                      zIndex="999"
                      bg="white"
                      maxH="150px"
                      overflow="hidden auto"
                    >
                      {suggestions.map((suggestion, index) => (
                        <MenuItem
                          key={index}
                          onClick={() => handleSelect(suggestion)}
                          cursor="pointer"
                          p="1rem"
                          py="0.5rem"
                          borderBottom="1px solid #E6E7E9"
                        >
                          <Text fontSize="0.875rem" fontWeight="500">
                            {suggestion.doctorname}
                          </Text>
                        </MenuItem>
                      ))}
                    </MenuList>
                  </Menu>
                )}
                {/* <PrimaryInput
                  inputPlace="Hospital name"
                  variant="downSide"
                  onChange={(e) =>
                    setHospitalname(handleAlphaNumericDotAndSpace(e.target.value))
                  }
                  inputValue={hospitalname}
                /> */}

                {/* <Textarea
                  mt='0.5rem'
                  borderRadius='10px'
                  placeholder="Instructions"
                  defaultValue={instructions}
                  onChange={handleInstructions}
                  inputValue={instructions}
                /> */}

                <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
                  <Box
                    as="form"
                    width='100%'
                    bg="white"
                    pt={"2px"}
                  >
                    <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
                      <Textarea
                        borderRadius='0'
                        value={editInstructions || ''}
                        onChange={(e) => {
                          handleEditInstructions(e.target.value);
                          setValue("textField", e.target.value); 
                        }}
                        height="100%"
                        padding="2"
                        resize="none"
                        style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                      />                      
                      {!editInstructions && (
                        <Text
                          position="absolute"
                          bottom="2"
                          left="50%"
                          transform="translateX(-50%)"
                          fontSize="sm"
                          color="gray.500"
                          w={{ base: "100%", md: "unset" }}
                          textAlign={{ base: "center", md: "unset" }}
                        >
                          {placeholder}
                        </Text>
                      )}
                    </Box>
                  </Box>
                </Box>
                {/* <Box mt=".5rem">
                  <Checkbox
                    colorScheme="green"
                    sx={{
                      ".chakra-checkbox__control": {
                        width: "20px",
                        height: "20px",
                        borderRadius: "5px",
                      },
                    }}
                    onChange={handleIsCurrent}
                  >
                    Current
                  </Checkbox>
                </Box> */}
              </Box>

              {/* Audio & Language Controls Row - Highlighted Section */}
                    <Box
                      bg="#f8f9fa"
                      border="1px solid #e9ecef"
                      borderRadius="8px"
                      p="1rem"
                      mt="1rem"
                      // mb="1rem"
                    >
                      <Flex
                        alignItems="center"
                        justifyContent="space-around"
                        // justifyContent="space-between"
                        gap="1rem"
                        flexWrap={{ base: "wrap", md: "nowrap" }}
                      >
                        {/* Input Language Dropdown */}
                        <Box flex="1" minW="120px">
                          <DropdownWithMultiLingual 
                            menuList={{pos:'relative', right:'75px'}}
                            placeholder="English"
                            onClick={handleChangeLanguage}
                            options={languageOptions.map(value => ({ value }))}
                            title="Input Language"
                          />
                        </Box>
                        
                        {/* Audio Controls and Wave Display */}
                        <Box 
                    flex="1"
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    gap="0.75rem"
                    minH="50px"
                    px="1rem"
                  >
                    <GPUChatAudioManagerSpeechMode
                      transcriber={activeTranscriber}
                      mode={mode}
                      setPlaceholder={setPlaceholder}
                      setTyping={setTyping}
                      onRecordingStateChange={handleRecordingStateChange} 
                    />
              
                    {isRecording && (
                      <Box flex="1" minW="180px" maxW="250px">
                        <AudioDisplayForClutter
                          borderRadius="lg"
                          stream={stream}
                          width="100%"
                        />
                      </Box>
                    )}
                  </Box>
              
                        {/* Output Language Dropdown */}
                        <Box flex="1" minW="120px">
                          <DropdownWithMultiLingual 
                            menuList={{pos:'relative', right:'75px'}}
                            placeholder="English"
                            onClick={handleChangeOutputLanguage}
                            options={languageOptions.map(value => ({ value }))}
                            title="Output Language"
                          />
                        </Box>
              
                        {/* AI Correction Button */}
                        <Box
                          as="button"
                          type="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="40px"
                          h="40px"
                          p="8px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          cursor={textFieldValue ? "pointer" : "not-allowed"}
                          opacity={textFieldValue ? 1 : 0.5}
                          pointerEvents={textFieldValue ? "auto" : "none"}
                          onClick={() => textFieldValue && correctOrders("edit")}
                          flexShrink="0"
                          bg="white"
                          _hover={textFieldValue ? { bg: "#f0f0f0" } : {}}
                        >
                          <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                        </Box>
                      </Flex>
                    </Box>
              {filenameArray.map((filename, indexToDelete) => (
                <Button
                  fontSize="14px"
                  fontWeight="500"
                  w="100%"
                  h="48px"
                  borderRadius="10px"
                  border="1px solid #E6E7E9"
                  display="flex"
                  justifyContent="space-between"
                  bg="white"
                  color="#1C4EC5"
                  sx={{ _hover: { bg: "none" } }}
                >
                  Document {indexToDelete + 1}
                  <Box as="span">
                    <Image src="/assets/imgs/delete.png" />
                  </Box>
                </Button>
              ))}
              <input
                type="file"
                id="file-upload"
                onChange={(e) => handleMedicationUpload(e)}
                ref={fileInputRef} // Set the ref for the file input
                style={{ display: "none" }} // Hide the file input
              />
            </Stack>
          </Box>
        </>
      }
      modalFooterBtn={
        <>
        {/* <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>        
          <GPUChatAudioManager
              transcriber={activeTranscriber}
              setPlaceholder={setPlaceholder}
              setTyping={setTyping}
                onTranscribedText={(text) => {
            handleEditInstructions(text);
            setValue("textField", text);
          }}
            />
            <Box
              as="button"
              type="button" 
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="auto"
              p="10px"
              mr='10px'
              display="flex"
              justifyContent="center"
              alignItems="center"
              cursor={textFieldValue ? "pointer" : "not-allowed"}
              opacity={textFieldValue ? 1 : 0.5}
              pointerEvents={textFieldValue ? "auto" : "none"}
              onClick={() => textFieldValue && correctOrders("edit")}
            >
              <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
            </Box>
        </Box> */}
          <PrimaryButton buttonText="Edit Medication" onClick={editmedicine} />
        </>
      }
    />

<ModalRight
        ref={detailsmodel}
        //header="Medicine details"
        bodyStyle={{ p: "24px 32px" }}
        modalWidth="360px"
        body={
          <>
            <Flex flexDir="column">
              <Box w="100%" mb="15px">
                <Box
                  fontSize="10px"
                  fontWeight="600"
                  bg="#E6E7E966"
                  border="1px solid #E6E7E9"
                  p="5px 10px"
                  borderRadius="full"
                  w="fit-content"
                >
                  {medicinedata && medicinedata.medicinetype
                    ? medicinedata.medicinetype
                    : ""}
                </Box>
                <Text fontSize="15px" fontWeight="600">
                  {medicinedata && medicinedata.medicinename
                    ? medicinedata.medicinename
                    : "-"}
                </Text>
                {/* <Text fontSize="12px" fontWeight="500" color="#384052"> */}
                  {/* {medicinedata && medicinedata.medicationenddate
                    ? medicinedata.medicationenddate
                    : "-"} */}
                  {/* {formatDate(medicinedata && medicinedata.medicationstartdate && medicinedata.medicationstartdate)}
                </Text> */}
                  
                <Text fontWeight="bold" fontSize="12px">
                Composition :
                <span style={{fontWeight:"500"}}>
                  {medicinedata && medicinedata.chemicalcomposition
                    ? medicinedata.chemicalcomposition
                    : "-"}
                    </span>
                </Text>
                <Text fontWeight="bold" fontSize="12px">
                Expiry :
                <span style={{fontWeight:"500"}}>
                  {medicinedata && medicinedata.medicineexpirydate
                    ? medicinedata.medicineexpirydate
                    : "-"}
                    </span>
                </Text>
              </Box>
              <Divider />
              <Box
                display="flex"
                flexDir="column"
                mt="15px"
                gap="12px"
                border="1px solid #E6E7E9"
                borderRadius="10px"
                p="20px"
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="start"
                  gap="10px"
                >
                  <Image src="/assets/svgs/pill-blue.svg" />
                  <Text fontSize="14px" fontWeight="500">
                    {medicinedata && medicinedata.frequency
                      ? medicinedata.frequency
                      : "-"}
                    x per day
                  </Text>
                  <Box display="flex" gap="5px">
                    <Box
                      as="span"
                      bg={
                        medicinedata && medicinedata.morning === 1
                          ? "#384052"
                          : "#E6E7E9"
                      }
                      borderRadius="full"
                      w="8px"
                      h="8px"
                      p="4px"
                    ></Box>
                    <Box
                      as="span"
                      bg={
                        medicinedata && medicinedata.evening === 1
                          ? "#384052"
                          : "#E6E7E9"
                      }
                      borderRadius="full"
                      w="8px"
                      h="8px"
                      p="4px"
                    ></Box>
                    <Box
                      as="span"
                      bg={
                        medicinedata && medicinedata.night === 1
                          ? "#384052"
                          : "#E6E7E9"
                      }
                      borderRadius="full"
                      w="8px"
                      h="8px"
                      p="4px"
                    ></Box>
                  </Box>
                </Box>
                {/* <Box display="flex" gap="10px" pr="4px">
                  <Image src="/assets/svgs/calendar_month.svg" />
                  <Text fontSize="14px" fontWeight="500">
                    {daysDiffrence} 
                  </Text>
                </Box> */}
                <Box display="flex" gap="10px" pr="4px">
                  <Image src="/assets/svgs/stethoscope.svg" />
                  <Text fontSize="14px" fontWeight="500" className="textOverflow">
                    {medicinedata && medicinedata.prescribedby
                      ? medicinedata.prescribedby
                      : "-"}
                  </Text>
                </Box>
                <Box display="flex" gap="10px" pr="4px">
                  <Image src="/assets/svgs/hospital.svg" />
                  <Text fontSize="14px" fontWeight="500" className="textOverflow">
                    {medicinedata && medicinedata.prescribedhospitalname
                      ? medicinedata.prescribedhospitalname
                      : "-"}
                  </Text>
                </Box>
              </Box>
              {/* <Button w="100%" h="48px" my="15px" borderRadius="10px" border="1px solid #E6E7E9" display="flex" justifyContent="space-between" bg="white" color="#1C4EC5" sx={{_hover: {bg:"none"}}}>
                    12/01/24_Report.pdf
                    <Box as="span">
                        <Image src="/assets/imgs/download.png" />
                    </Box>
                </Button>  */}
              {medicinedata && medicinedata.documents && medicinedata.documents.map((document, index) => (
                <Button
                  key={index}
                  w="100%"
                  h="48px"
                  my="15px"
                  borderRadius="10px"
                  border="1px solid #E6E7E9"
                  display="flex"
                  justifyContent="space-between"
                  bg="white"
                  color="#1C4EC5"
                  sx={{ _hover: { bg: "none" } }}
                  onClick={()=>downloadDocument(document.imagepath + document.documenturl)}
                  cursor="pointer"
                >
                  Document {index + 1}
                  {document.documenturl != null && (
                    <Box as="span">
                      <Image src="/assets/imgs/download.png" />
                    </Box>
                  )}
                </Button>
              ))}
            </Flex>
          </>
        }
        footerActions={
          <>
            <Box w="100%" display="flex" flexDirection="row" gap="15px">
              <PrimaryButton onClick={() => handleeditmedication(medicinedata)} btnStyle={{fontSize:"14px", my: "0"}} variant="grayBtnFull" buttonText="Update Medication" isDisabled={false} />
              <PrimaryButton
                variant="grayBtnFull"
                color="#AA2E26"
                btnStyle={{ color: "#AA2F27", fontSize:"14px", my: "0" }}
                buttonText="Delete Medication"
                isDisabled={false}
                onClick={() =>
                  DeleteMedicineModel(
                    medicinedata && medicinedata.medicinename,
                    medicinedata && medicinedata.id
                  )
                }
              />
            </Box>
          </>
        }
      />

<AiModal
        ref={AIChatModel}
      modalSize="420px"
      //icon="/assets/imgs/ai-doctor.png"
      header={<>
        <Box display="flex" flexDir='column'>
          <Text fontSize="1rem" fontWeight="700" backgroundImage="linear-gradient(to right top, #0d7e54, #007774, #006d94, #005ea7, #1146a0)" color="transparent" backgroundClip="text">Aira - AI</Text>
          <Text fontSize="0.75rem" fontWeight="400">Chat with your AI health guide</Text>
        </Box>
      </>}
      headerStyle={{ p: "24px 32px", lineHeight: "normal" }}
      closeBtnStyle={{ top: "18px" }}
      footerStyle={{ maxH: "35%", overflow: "hidden auto", boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}
      withoutBg={true}
      backDropBlur="10px"
      body={
        <>
          <Flex flexDirection="column" height="100%">
            <Box
              p="24px 32px"
              ref={chatContainerRef}
              className="chat-container"
              style={{ overflowY: "auto", maxHeight: 'calc(100vh - 160px)' }}
            >
              {initialRender && remainingquestions.length > 0 && (
                <Box>
                  {remainingquestions.map((step, index) => (
  <Box
    key={index}
    as="button"
    w="100%"
    p="16px"
    mb="16px"
    fontSize="14px"
    fontWeight="600"
    display="flex"
    flexDirection="row"
    alignItems="center"
    justifyContent="space-between"
    borderRadius="10px"
    border={isChatbotAllowed() ? "1px solid #7795DC" : "1px solid #CCCCCC"}
    bg={isChatbotAllowed() ? "#EAEDF5" : "#F5F5F5"}
    color={isChatbotAllowed() ? "#163E9E" : "#888888"}
    onClick={() => {
      if (isChatbotAllowed()) {
        GetAIAnswer(step.value);
      } else {
        showErrorToast("Please upgrade your subscription to use AI features");
      }
    }}
    className={`question-box ${animate ? "slide-in" : ""}`}
    cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
    opacity={isChatbotAllowed() ? 1 : 0.7}
    title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
  >
    {step.value ? step.value : "-"}
    <Image 
      src="/assets/imgs/right-icon.png" 
      opacity={isChatbotAllowed() ? 1 : 0.5}
      filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
    />
  </Box>
))}
                  {/* {remainingquestions.map((step, index) => (
                    <Box
                      key={index}
                      as="button"
                      w="100%"
                      p="16px"
                      mb="16px"
                      fontSize="14px"
                      fontWeight="600"
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      textAlign='left'
                      gap='10px'
                      justifyContent="space-between"
                      borderRadius="10px"
                      border="1px solid #7795DC"
                      bg="#EAEDF5"
                      color="#163E9E"
                      onClick={() => GetAIAnswer(step.value)}
                      className={`question-box ${animate ? 'slide-in' : ''}`}
                    >
                      {step.value ? step.value : "-"}
                      <Image src="/assets/imgs/right-icon.png" />
                    </Box>
                  ))} */}
                </Box>
              )}
              {aianswers.map((step, index) => (
                <React.Fragment key={index}>
                  <Box
                    as="div"
                    bg="#061027"
                    p="12px 16px"
                    w="fit-content"
                    float="right"
                    borderRadius="10px 10px 1px 10px"
                    className={`answer-box ${animate ? 'slide-in' : ''}`}
                  >
                    <Text fontSize="14px" fontWeight="500" color="white">
                      {step.question ? step.question : "-"}
                    </Text>
                  </Box>

                  <Box
                    as="div"
                    my="20px"
                    w="fit-content"
                    display="flex"
                    alignItems="end"
                    float="left"
                    className={`answer-box ${animate ? 'slide-in' : ''}`}
                  >
                    <Image
                      bg="#061027"
                      p="4px"
                      mr="8px"
                      borderRadius="6px"
                      src="/assets/imgs/ai-chat-logo.png"
                    />
                    <Text
                      bg="#E6E7E980"
                      p="12px 16px"
                      fontSize="14px"
                      fontWeight="500"
                      color="#061027"
                      borderRadius="10px 10px 10px 1px"
                    >
                      {step.answer ? step.answer : <TypingLoader />}
                    </Text>
                  </Box>
                </React.Fragment>
              ))}
            </Box>
          </Flex>
        </>
      }
      footerActions={
        !initialRender && (
          <Box
            p="24px 32px"
            display="flex"
            w="100%"
            h="100%"
            flexDirection="column"
            justifyContent="space-between"
          >
            <Box w="100%">
              {remainingquestions.map((step, index) => (
  <Box
    key={index}
    as="button"
    w="100%"
    p="16px"
    mb="16px"
    fontSize="14px"
    fontWeight="600"
    display="flex"
    flexDirection="row"
    alignItems="center"
    justifyContent="space-between"
    borderRadius="10px"
    border={isChatbotAllowed() ? "1px solid #7795DC" : "1px solid #CCCCCC"}
    bg={isChatbotAllowed() ? "#EAEDF5" : "#F5F5F5"}
    color={isChatbotAllowed() ? "#163E9E" : "#888888"}
    onClick={() => {
      if (isChatbotAllowed()) {
        GetAIAnswer(step.value);
      } else {
        showErrorToast("Please upgrade your subscription to use AI features");
      }
    }}
    className={`question-box ${animate ? "slide-in" : ""}`}
    cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
    opacity={isChatbotAllowed() ? 1 : 0.7}
    title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
  >
    {step.value ? step.value : "-"}
    <Image 
      src="/assets/imgs/right-icon.png" 
      opacity={isChatbotAllowed() ? 1 : 0.5}
      filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
    />
  </Box>
))}
              {/* {remainingquestions.map((step, index) => (
                <Box
                  key={index}
                  as="button"
                  w="100%"
                  p="16px"
                  mb="16px"
                  fontSize="14px"
                  fontWeight="600"
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="space-between"
                  borderRadius="10px"
                  border="1px solid #7795DC"
                  bg="#EAEDF5"
                  color="#163E9E"
                  onClick={() => GetAIAnswer(step.value)}
                  className={`question-box ${animate ? 'slide-in' : ''}`}
                >
                  {step.value ? step.value : "-"}
                  <Image src="/assets/imgs/right-icon.png" />
                </Box>
              ))} */}
            </Box>
          </Box>
        )
      }
    />

    {/* <DynamicModal
      ref={favouritemedications}
      modalHeader="Add To Favourite?"
      modalBody={
        <>
          <Text fontSize="14px" fontWeight="600">
            Are you sure you want to add
            <strong> "{medicinename}"</strong> to favourite medicines?
          </Text>
        </>
      }
      modalFooterBtn={
        <>
          <PrimaryButton
            // variant="deleteBtn"
            buttonText="Add to Favourites"
            onClick={handleSaveFavouriteMedicine}
          />
        </>
      }
    /> */}
    <DynamicModal
  ref={favouritemedications}
  modalHeader={isAddingToFav ? "Add To Favourite?" : "Remove From Favourite?"}
  modalBody={
    <>
      <Text fontSize="14px" fontWeight="600">
        Are you sure you want to {isAddingToFav ? "add" : "remove"}
        <strong> "{medicinename}"</strong> {isAddingToFav ? "to" : "from"} favourite medicines?
      </Text>
    </>
  }
  modalFooterBtn={
    <>
      <PrimaryButton
        variant={isAddingToFav ? "primary" : "deleteBtn"}
        buttonText={isAddingToFav ? "Add to Favourites" : "Remove from Favourites"}
        onClick={handleFavouriteAction}
      />
    </>
  }
/>

    <DynamicModal
      ref={dynamicModal}
      modalHeader="Delete Medicine?"
      modalBody={
        <>
          <Text fontSize="14px" fontWeight="600">
            Are you sure you want to delete
            <strong> {medName ? `"${medName}"` : "this medicine"}</strong>?
            {/* <strong> "{medName}"</strong>? */}
          </Text>
        </>
      }
      modalFooterBtn={
        <>
          <PrimaryButton
            variant="deleteBtn"
            buttonText="Delete"
            onClick={deleteMedicine}
          />
        </>
      }
    />

    <DynamicModal
      ref={administration}
      hasFooter={false}
      modalHeader="Administration Details"
      modalBody={
        <>
          <Box w="100%">
          <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    mb="0.75rem"
                                  >
                                    <Box
                                      cursor="pointer"
                                      display="flex"
                                      alignItems="center"
                                      flex="1"
                                      minW="0"
                                    >
                                      <Box display="flex" flex="1" minW="0">
                                        <Text
                                          fontSize="15px"
                                          fontWeight="600"
                                          isTruncated
                                          textOverflow="ellipsis"
                                          whiteSpace="nowrap"
                                          overflow="hidden"
                                          title={`${modalData.medicinename} (${modalData.medicinetype}${" "} ${" "}`}
                                          maxW="100%"
                                        >
                                          <Box as="span" bg='#E6E7E966' mr='0.25rem' border='1px solid #E6E7E9' borderRadius='8px' fontSize='10px' p='0.25rem'>
                                            {modalData.medicinetype ? modalData.medicinetype : "-"}
                                          </Box>
                                          {modalData.medicinename} 
                                        </Text>
                                      </Box>
                                    </Box>
                                    </Box>

                                    <Flex w="100%" mb="0.75rem" justifyContent="space-between">
                                    <Box display="flex" flexDir="column" w={"100%"}>
                                      <Text fontSize="10px" color="gray.500">
                                        Composition
                                      </Text>
                                      <Text fontSize="12px" fontWeight="600">
                                        {modalData?.chemicalcomposition ? modalData?.chemicalcomposition : "-"} - ({modalData.dosage}{" "} {modalData.dosageunit}){" "}
                                      </Text>
                                    </Box>
                                  </Flex>

                                  <Flex w="100%" gap='10px'>
                                    <Box display="flex" flexDir="column" w={"100%"}>
                                      <Text fontSize="10px" color="gray.500">
                                       Drug Class
                                      </Text>
                                      <Text fontSize="12px" fontWeight="600">
                                        {modalData.drugclass ? modalData.drugclass : "-"}
                                      </Text>
                                    </Box>
                                    <Box display="flex" flexDir="column"  w="100%">
                                      <Text fontSize="10px" color="gray.500">
                                      Therapeutic
                                      </Text>
                                      <Box as="button" w="100%">
                                        <Text
                                          fontSize="12px"
                                          fontWeight="600"
                                          isTruncated
                                          textAlign="left"
                                        >
                                          {modalData?.therapeutic ? modalData?.therapeutic : "-"}
                                        </Text>
                                      </Box>
                                    </Box>
                                    <Box w="100%" display="flex" flexDir="column">
                                      <Text fontSize="10px" color="gray.500">
                                      Manufacturer
                                      </Text>
                                      <Text fontSize="12px" fontWeight="600">
                                      {modalData?.manufacturer ? modalData?.manufacturer : "-"}
                                      </Text>
                                      
                                    </Box>
                                  </Flex>
            <Flex w="100%" mt="0.75rem" mb="0.75rem" justifyContent="space-between">
              <Box display="flex" flexDir="column" w={"100%"}>
                <Text fontSize="10px" color="gray.500">
                  Duration
                </Text>
                <Text fontSize="12px" fontWeight="600">
                  {modalData.duration ? modalData.duration : "-"}
                </Text>
              </Box>
              <Box display="flex" flexDir="column" alignItems="end" w="100%">
                <Text fontSize="10px" color="gray.500">
                  Timing details
                </Text>
                <Box as="button" w="100%">
                  <Text
                    fontSize="12px"
                    fontWeight="600"
                    isTruncated
                    textAlign="right"
                  >
                    {modalData.frequencytime && modalData.frequencyvalue ? (
                      <>
                        {modalData.frequencytime === "Hours"
                          ? `Every ${modalData.frequencyvalue} ${modalData.frequencytime}`
                          : `${modalData.frequencytime} ${
                              modalData.frequencyvalue === 1
                                ? "once"
                                : modalData.frequencyvalue === 2
                                  ? "twice"
                                  : modalData.frequencyvalue === 3
                                    ? "thrice"
                                    : `${modalData.frequencyvalue} times`
                            }`}
                      </>
                    ) : (
                      <>
                        {modalData.morning}-{modalData.afternoon}-{modalData.night}
                      </>
                    )}
                  </Text>
                </Box>
              </Box>
            </Flex>
              <Box display="flex" flexDir="column" w={"100%"}>
                <Text fontSize="10px" color="gray.500">
                  Instructions
                </Text>
                <Text fontSize="12px" fontWeight="600">
                  {modalData.instructions == null ? '-' : modalData.instructions}
                  {/* {modalData.instructions == null ? adminData.instructions : modalData.instructions} */}
                </Text>
              </Box>
          </Box>
        </>
      }
    />;

    </>
  )
}

export default MedicineViewIndex;
